var map = {
	"./1C-Bitrix.svg": "k+0i",
	"./2badvice.png": "zpHC",
	"./30namaPlayer.png": "PRhZ",
	"./33Across.png": "3hS6",
	"./34SP.com.svg": "X48G",
	"./3dCart.png": "lWxz",
	"./4-Tell.png": "0uHC",
	"./8base-logo.png": "axe6",
	"./91app.png": "m+56",
	"./A-Frame.svg": "XvwK",
	"./A8.net.png": "xWp6",
	"./AB Tasty.svg": "EcZm",
	"./ABOUT YOU Commerce Suite.svg": "823P",
	"./ADFOX.svg": "Evf0",
	"./ADPLAN.png": "j46G",
	"./AFThemes.png": "2rbx",
	"./AIOSEO.svg": "xTOX",
	"./ALL-INKL.png": "lGft",
	"./AOLserver.png": "UcZf",
	"./AOS.svg": "XjOi",
	"./APC.svg": "CD0Z",
	"./ARI Network Services.png": "wult",
	"./AT Internet.png": "sknM",
	"./ATSHOP.png": "30Lw",
	"./AWIN.svg": "3Rtx",
	"./AWStats.png": "OFBq",
	"./Absorb.svg": "x3vc",
	"./Accelerated-Mobile-Pages.svg": "4srn",
	"./Accentuate Custom Fields.png": "7bHh",
	"./AccessTrade.png": "uX8Q",
	"./AccessiBe.svg": "3ZC9",
	"./Accessibe.png": "Jq8U",
	"./Accessibility Toolbar Plugin.png": "XARg",
	"./Accessible360.png": "bbP6",
	"./Accessibly.svg": "CePt",
	"./Accesso.svg": "+hKp",
	"./AccuWeather.svg": "ihxr",
	"./Ace.png": "I+SA",
	"./Ackee.png": "mExk",
	"./Acoustic.svg": "rbM+",
	"./Acquire.svg": "W3LE",
	"./Act-On.svg": "rzBN",
	"./Actito.png": "FgwN",
	"./ActiveCampaign.svg": "9QQa",
	"./Acuity Scheduling.png": "kvWK",
	"./AcuityAds.svg": "m2XA",
	"./Ad Lightning.svg": "XASg",
	"./AdBridg.png": "eOtB",
	"./AdInfinity.png": "qNO2",
	"./AdOcean.png": "fOxV",
	"./AdOpt.svg": "u4gQ",
	"./AdRiver.png": "WhZT",
	"./AdRoll.svg": "kbCm",
	"./AdScale.svg": "busl",
	"./AdThrive.png": "wMhG",
	"./Ada.svg": "C8hV",
	"./AdaSiteCompliance.png": "01O7",
	"./Adabra.svg": "U6/B",
	"./Adally.png": "pbua",
	"./Adalyser.svg": "xN4T",
	"./Adcash.svg": "jCCM",
	"./AddSearch.png": "Lp8k",
	"./AddShoppers.png": "bICW",
	"./AddThis.svg": "Xcrx",
	"./AddToAny.png": "2LG9",
	"./AddToAny.svg": "UXzX",
	"./Addsearch.svg": "t4g6",
	"./Adform.svg": "p/IY",
	"./Adloox.png": "mwR+",
	"./Admiral.svg": "hjIU",
	"./Admitad.svg": "8jqy",
	"./Admixer.svg": "ZHXs",
	"./Admo.tv.svg": "X+Gk",
	"./Adnegah.png": "sZhe",
	"./Adobe Analytics.svg": "/PQ/",
	"./Adobe ColdFusion.svg": "2U2U",
	"./Adobe Experience Platform.svg": "1aBB",
	"./Adobe Flash.svg": "aQAh",
	"./Adobe GoLive.png": "tk1x",
	"./Adobe RoboHelp.svg": "g4yU",
	"./Adobe.svg": "u571",
	"./AdonisJS.png": "fUuQ",
	"./Advally.png": "5qtY",
	"./Advanced Custom Fields.png": "IJgw",
	"./Advanced Web Stats.png": "MMZO",
	"./Advert Stream.png": "wJWj",
	"./Adverticum.svg": "QMi/",
	"./Adyen.svg": "hiiU",
	"./Adzerk.png": "n9bS",
	"./Aegea.png": "nvSF",
	"./Aero Commerce.svg": "lxqH",
	"./Affilae.png": "+fU7",
	"./Affiliate B.svg": "2eh2",
	"./Affiliate Future.png": "qRfL",
	"./Affiliatly.png": "Dpwy",
	"./Affilo.png": "mGuq",
	"./Affirm.svg": "wJyv",
	"./Afosto.svg": "9HtD",
	"./AfterBuy.png": "yBpO",
	"./AfterSell.svg": "G+fh",
	"./AfterShip Returns Center.svg": "gpH0",
	"./AfterShip.svg": "chH7",
	"./AiSpeed.png": "D6fA",
	"./Aimtell.png": "bs9h",
	"./Air360.png": "V2uP",
	"./AirRobe.png": "MeRR",
	"./Airee.png": "c5AY",
	"./Airform.svg": "OAef",
	"./Airship.svg": "K93z",
	"./Akismet.png": "5S2P",
	"./Aksara CMS.svg": "htHR",
	"./Albacross.svg": "sDSu",
	"./AlertifyJS.png": "RmLj",
	"./Alexa.svg": "uUOi",
	"./Algolia.svg": "uzVA",
	"./Alireviews.svg": "E6+8",
	"./Allegro RomPager.png": "lGYi",
	"./Alli.png": "uIa+",
	"./AlloyUI.png": "ThEp",
	"./Allyable.png": "owut",
	"./AlmaLinux.svg": "NQiT",
	"./Alpine Linux.svg": "yCu/",
	"./Alpine.js.png": "1lxs",
	"./AlternC.png": "boAT",
	"./Amaya.png": "Mqw0",
	"./Amazon Pay.svg": "GxPa",
	"./Amazon Webstore.svg": "KIe6",
	"./Amazon-Cloudfront.svg": "Bgtt",
	"./Amazon.svg": "t4Vs",
	"./Ambassador.png": "7cdr",
	"./AmeriCommerce.png": "iyqo",
	"./Ametys.png": "Or3o",
	"./Amex.svg": "Pl4j",
	"./Amiro.CMS.png": "6gEd",
	"./Amobee.png": "mjas",
	"./Amplience.png": "SAkf",
	"./Amplitude.svg": "MCvJ",
	"./Analysys Ark.svg": "JIs3",
	"./AndersNoren.svg": "zLyt",
	"./Anetwork.png": "iXhE",
	"./Angular.svg": "d+so",
	"./AngularDart.svg": "M9b6",
	"./AngularJS.svg": "LV/N",
	"./AnswerDash.png": "oPB6",
	"./Ant Design.svg": "X5/o",
	"./AntV.svg": "QZDz",
	"./Antsomi.svg": "tUuQ",
	"./AnyClip.svg": "vWeK",
	"./Apache JSPWiki.png": "4MIj",
	"./Apache Tomcat.svg": "vL4S",
	"./Apache Traffic Server.png": "77Bv",
	"./Apache Wicket.svg": "0xWg",
	"./Apache.svg": "u8of",
	"./ApexPages.png": "0zTh",
	"./Apisearch.png": "Om1l",
	"./Aplazame.svg": "EcjD",
	"./Apollo.svg": "zb73",
	"./Apollo13Themes.png": "F9bn",
	"./ApostropheCMS.svg": "zGOJ",
	"./AppDynamics.png": "IVy4",
	"./AppNexus.svg": "FBWL",
	"./Appcues.png": "1f/O",
	"./Appcues.svg": "Yflu",
	"./Appian.png": "BsB0",
	"./Apple.svg": "dB00",
	"./ApplicantStack.png": "cW58",
	"./Appointy.png": "tcOv",
	"./Appsflyer.svg": "VnYW",
	"./Apptus.svg": "TzO6",
	"./Aprimo.png": "SHM0",
	"./AquilaCMS.svg": "2GR4",
	"./Arastta.svg": "o2d/",
	"./Arc XP.svg": "hvlX",
	"./Arc-Publishing.svg": "Lk+2",
	"./Arc.svg": "jox6",
	"./Artifactory.svg": "SBZf",
	"./Aruba.it.svg": "mvZo",
	"./ArvanCloud.png": "NWlB",
	"./Asana.svg": "ylSH",
	"./AsciiDoc.png": "Rw7Y",
	"./Asciidoctor.png": "olOo",
	"./Asendia.svg": "ysXS",
	"./Astra.svg": "O51z",
	"./Astro.svg": "EIRa",
	"./Astute Solutions.svg": "IZQR",
	"./Atatus.svg": "96TU",
	"./Athena Search.svg": "LxHD",
	"./Atlassian Bitbucket.svg": "ctgx",
	"./Atlassian Confluence.svg": "nLCw",
	"./Atlassian FishEye.svg": "pVj/",
	"./Atlassian Jira.svg": "CvzJ",
	"./Atlassian Statuspage.svg": "PN24",
	"./Attentive.svg": "D+9i",
	"./Attraqt.png": "QRHD",
	"./AudioEye.svg": "YkKi",
	"./Audiohook.svg": "kxiS",
	"./Aurelia.svg": "Vcy8",
	"./Auryc.svg": "+XU1",
	"./AusPost.svg": "sB24",
	"./Auth0.png": "AajI",
	"./Auth0.svg": "yhFi",
	"./Autoketing.png": "RaiH",
	"./Automizely.svg": "mMAo",
	"./Autopilot.png": "xmgt",
	"./Autoptimize.png": "92VQ",
	"./Avada.svg": "v8Jb",
	"./Avangate.svg": "mEJe",
	"./Avasize.png": "JRnO",
	"./Avis Verifies.png": "2GB3",
	"./Aweber.svg": "Qhsy",
	"./Axeptio.png": "wFdc",
	"./Azion.svg": "aLKv",
	"./AzureADB2C.png": "w567",
	"./B2C Europe.svg": "ImxM",
	"./BEM.png": "THkw",
	"./BIGACE.png": "cyGO",
	"./BON Loyalty.svg": "nHe5",
	"./BRT.svg": "wq44",
	"./BSmart.png": "FXyM",
	"./Babel.svg": "Cev8",
	"./Babylist.svg": "rxP1",
	"./Back In Stock.png": "MP+7",
	"./Backbone.js.png": "udbJ",
	"./Backdrop.png": "1kXZ",
	"./Baidu Maps.png": "SX79",
	"./Baidu Tongji.png": "vVEd",
	"./BambooHR.svg": "66gm",
	"./Bambuser.png": "VAOc",
	"./BandsInTown.png": "pgC1",
	"./Banshee.png": "ThpF",
	"./Barba.js.png": "Vwta",
	"./Base.svg": "CvfK",
	"./Basis.png": "fhV8",
	"./Batflat.svg": "D6kg",
	"./Bazaarvoice.png": "+cP6",
	"./Beam.svg": "XNb8",
	"./Beans.svg": "Jmzc",
	"./Beeketing.svg": "Uvl+",
	"./Beeswax.png": "CP05",
	"./Bentobox.svg": "Sf6Y",
	"./Better Price.png": "seP3",
	"./Betty Blocks.svg": "9KcC",
	"./Beyable.png": "Xdkw",
	"./BeyondMenu.png": "aeVh",
	"./Big Cartel.svg": "zaYP",
	"./BigCommerce.svg": "Rcwd",
	"./Bigware.png": "r7Ff",
	"./Bikayi.svg": "2Ly+",
	"./Billbee.png": "3C6d",
	"./Birdeye.svg": "m0w3",
	"./Bitcoin.svg": "xXc7",
	"./BiteSpeed.png": "4nsR",
	"./Bitrix24.svg": "SwRi",
	"./BittAds.png": "8HMa",
	"./Blackbaud-Luminate-Online.png": "LUpN",
	"./Blade.png": "N5oT",
	"./Blazor.png": "kbHg",
	"./Blessing Skin.png": "NYNp",
	"./Blesta.png": "A0NJ",
	"./Blip.tv.png": "O4dp",
	"./Blitz.svg": "mX2N",
	"./Blocksy.svg": "WXYz",
	"./Blogger.png": "JGgU",
	"./Bloomreach.png": "j+WK",
	"./Bloomreach.svg": "xybz",
	"./Blossom.png": "3CP1",
	"./Blue Triangle.png": "OZ86",
	"./Blue.svg": "/2GQ",
	"./BlueConic.svg": "MRGH",
	"./Bluecore.svg": "MzyA",
	"./Bluefish.png": "9yHV",
	"./Bluehost.svg": "1ifu",
	"./Blueknow.png": "Hubf",
	"./Blueshift.png": "NdCb",
	"./Boats Group.png": "4kxe",
	"./Bokun.svg": "qNpA",
	"./Bol.com.svg": "+hgZ",
	"./Bold.svg": "EPHZ",
	"./BoldChat.png": "83lD",
	"./Bolt CMS.png": "8clG",
	"./Bolt.png": "ZJSo",
	"./Bolt.svg": "u9zh",
	"./Bonfire.png": "gLuz",
	"./BookDinners.svg": "0a6j",
	"./BookThatApp.png": "I/dk",
	"./Bookatable.svg": "RUUV",
	"./Bookero.svg": "6YQ4",
	"./Booking.com.svg": "S2iT",
	"./Bookingkit.svg": "BllZ",
	"./Booksy.svg": "s64D",
	"./Boost Commerce.png": "yQcp",
	"./BoosterApps.png": "gZ4A",
	"./Bootstrap Icons.svg": "JVfO",
	"./Bootstrap Table.svg": "l2wZ",
	"./Bootstrap.svg": "ZXWK",
	"./Booxi.svg": "sd4j",
	"./Borderfree.png": "nMV7",
	"./Borlabs Cookie.svg": "waHI",
	"./Botble-CMS.png": "Uz4k",
	"./Boutiq.svg": "1BlA",
	"./BowNow.png": "TfMM",
	"./Boxtal.svg": "HWGy",
	"./Bpost.svg": "P6vz",
	"./BrainSINS.png": "bNJX",
	"./Braintree.svg": "fN+B",
	"./Branch.png": "QHQL",
	"./Brandfolder.svg": "RCPL",
	"./Braze.svg": "Acw7",
	"./Bread.svg": "DNZd",
	"./Breadcrumb NavXT.svg": "SE/e",
	"./Breinify.png": "vA/+",
	"./Bricksite.svg": "bcfh",
	"./BrightEdge.png": "OjQq",
	"./BrightInfo.png": "NxuS",
	"./Brightcove.png": "RrpD",
	"./Brightspot.svg": "di3Y",
	"./Broadstreet.png": "39zW",
	"./Bronto.svg": "js6P",
	"./Brownie.svg": "CjfO",
	"./Browser-Update.org.png": "45hI",
	"./BrowserCMS.png": "zcOM",
	"./Bsale.png": "dp9V",
	"./Budbee.svg": "97fi",
	"./BuddyPress.svg": "Kxji",
	"./BugHerd.svg": "IZYK",
	"./BugSnag.png": "mY6I",
	"./Bugcrowd.svg": "saMC",
	"./Bugzilla.png": "CosB",
	"./Builder.svg": "blHv",
	"./Buildertrend.svg": "xr4w",
	"./Bulma.png": "kNHu",
	"./Bulma.svg": "vWhP",
	"./Bump.svg": "GwQo",
	"./Bunny.png": "zbE+",
	"./Business Catalyst.svg": "Kgu7",
	"./Buy me a coffee.svg": "anMx",
	"./BuySellAds.svg": "lw3o",
	"./Buyapowa.svg": "F4sI",
	"./BySide.svg": "syTb",
	"./Bynder.svg": "aSbw",
	"./C.png": "t8dh",
	"./CDN77.png": "MrFP",
	"./CFML.png": "nsG7",
	"./CJDropshipping.svg": "78KZ",
	"./CKEditor.png": "qcLq",
	"./CMS Made Simple.png": "d8dU",
	"./CPG Dragonfly.png": "lag8",
	"./CS Cart.png": "7flW",
	"./CS Cart.svg": "esij",
	"./CSSIgniter.svg": "GKWc",
	"./CTT.svg": "rDmN",
	"./Caast.tv.png": "iW6J",
	"./CacheFly.svg": "6GFT",
	"./Cafe24.png": "4DrP",
	"./Cafe24.svg": "K4c3",
	"./CakePHP.png": "kkwQ",
	"./Caldera Forms.png": "vfBd",
	"./CalendarHero.png": "ahi6",
	"./Calendly.svg": "FTOq",
	"./CallRail.png": "nhPF",
	"./Callbell.svg": "8Ts3",
	"./Campaign Monitor.svg": "CeFO",
	"./Candid Themes.png": "VdbZ",
	"./Canto.svg": "mDQh",
	"./Captch Me.svg": "QmJI",
	"./Carbon Ads.png": "wE9w",
	"./CareCart.png": "eAq4",
	"./Cargo.svg": "0bWx",
	"./Carrd.svg": "om17",
	"./Carro.svg": "h6wg",
	"./Cart-generic.svg": "K+w3",
	"./Cart.com.svg": "9aNR",
	"./Cart.js.png": "nECN",
	"./CartKit.svg": "+N+L",
	"./CartStack.svg": "7/ui",
	"./Carts Guru.png": "CGf1",
	"./Cashew Payments.svg": "2cn+",
	"./Catberry.js.png": "68X/",
	"./Catch Themes.png": "3PyX",
	"./Catch.svg": "D9X2",
	"./Cecil.svg": "wZ4e",
	"./Celeritas.svg": "rW/x",
	"./Celum.svg": "qjga",
	"./Censhare.svg": "wVQ+",
	"./CentOS.png": "XRJz",
	"./Ceres.svg": "ObQ9",
	"./Chabokan.svg": "Fnlh",
	"./Chakra UI.svg": "5N6o",
	"./Chameleon system.png": "HCzJ",
	"./Chameleon.png": "jSSY",
	"./Chamilo.png": "mLQi",
	"./ChannelAdvisor.svg": "EuJP",
	"./ChannelApe.svg": "bI6L",
	"./Chaport.png": "qu08",
	"./ChargeAfter.svg": "TmvI",
	"./Chargebee.svg": "E5RX",
	"./Chart.js.svg": "2sVk",
	"./Chartbeat.png": "qwjI",
	"./Chatango.png": "NYtK",
	"./Chatra.svg": "Hsp4",
	"./Chatwoot.svg": "vE/Y",
	"./Checkfront.svg": "UUgG",
	"./Checkout.com.svg": "0yKD",
	"./Chekkit.png": "0Fqy",
	"./Cherokee.png": "uqyB",
	"./CherryPy.svg": "1pKa",
	"./Chevereto.svg": "7CJr",
	"./Chili Piper.svg": "Af+s",
	"./Chinese Menu Online.png": "YkBD",
	"./Chitika.png": "5o7t",
	"./Choices.png": "i4Cc",
	"./Chord.svg": "qPEn",
	"./Chorus.png": "i3ra",
	"./Chorus.svg": "bQBJ",
	"./Chronopost.svg": "jv4S",
	"./ChurnZero.png": "KD0V",
	"./City Hive.png": "tMOA",
	"./CityMail.png": "5NtN",
	"./Ckan.png": "I+Pr",
	"./Classeh.svg": "RWWv",
	"./ClearSale.svg": "eBEr",
	"./Clearbit.png": "mY+3",
	"./Clerk.io.svg": "Bkva",
	"./CleverTap.png": "1F0g",
	"./Cleverbridge.svg": "9Efp",
	"./ClickCease.svg": "xS+A",
	"./ClickDimensions.png": "MnzD",
	"./ClickFunnels.png": "Lmyn",
	"./ClickFunnels.svg": "y4P8",
	"./ClickHeat.png": "Kxsv",
	"./ClickTale.png": "5yQK",
	"./Clickbank.svg": "UnmC",
	"./Clicky.png": "OXV3",
	"./ClientJS.png": "aI6Y",
	"./Clinch.png": "vj8H",
	"./Clipboard.js.svg": "7pWp",
	"./CloudFlare.svg": "uXhC",
	"./CloudSuite.svg": "W02X",
	"./Cloudbeds.svg": "JT3G",
	"./Cloudera.png": "Ke0x",
	"./Cloudimage.svg": "Y4fo",
	"./Cloudinary.svg": "WzS6",
	"./Cloudways.png": "zk3P",
	"./Cloverly.svg": "uJoJ",
	"./Cluep.png": "XeJW",
	"./ClustrMaps.svg": "u9Fy",
	"./CoConstruct.png": "K/Sw",
	"./CoRover.png": "bmIs",
	"./Cococart.png": "SAAr",
	"./CoconutSoftware.svg": "owbV",
	"./Cocos2d.png": "0qu8",
	"./CodeIgniter.png": "u7ej",
	"./CodeMirror.png": "AAlK",
	"./CodeSandbox.svg": "YDqT",
	"./Coin Currency Converter.png": "KRz7",
	"./CoinHive.svg": "Kgxz",
	"./Coinbase.svg": "ZR/Z",
	"./Colibri WP.png": "gn4g",
	"./Colis Prive.svg": "Po7x",
	"./Colorlib.png": "nmyQ",
	"./Comandia.svg": "tinT",
	"./Combeenation.png": "rH0S",
	"./Comm100.svg": "Z54M",
	"./Commanders Act.svg": "yIh2",
	"./Commerce Server.png": "42ld",
	"./Commerce7.svg": "U/n+",
	"./Complianz.png": "Eepi",
	"./Concrete CMS.svg": "2l/m",
	"./Concrete5.png": "qnhK",
	"./Conekta.svg": "KHRX",
	"./Confer With.svg": "KeQx",
	"./Conjured.png": "5xn0",
	"./Connectif.svg": "RTOl",
	"./Constant Contact.svg": "nepc",
	"./Contabo.svg": "LQm0",
	"./Contact Form 7.png": "FsYd",
	"./Contao.svg": "GOdP",
	"./Contenido.png": "PRbI",
	"./Contensis.png": "yXz2",
	"./ContentBox.png": "sHBs",
	"./ContentSquare.png": "KGkV",
	"./ContentStudio.png": "SL9H",
	"./Contentful.svg": "HrIV",
	"./Contently.png": "sEyh",
	"./Contentsquare.svg": "s/9O",
	"./Contentstack.png": "vZIJ",
	"./Contlo.png": "OtNF",
	"./Conversant.svg": "Zt7s",
	"./Convert.png": "9lIw",
	"./ConvertFlow.svg": "4mxj",
	"./ConvertKit.svg": "rihT",
	"./Convertcart.svg": "iUfi",
	"./Convertr.svg": "IWQW",
	"./ConveyThis.png": "gr96",
	"./Cookie Information.svg": "/8XP",
	"./Cookie Notice.png": "fEn6",
	"./CookieFirst.png": "AExN",
	"./CookieHub.png": "GJDk",
	"./CookieScript.png": "kLBQ",
	"./CookieScript.svg": "HAN8",
	"./Cookiebot.svg": "ojVa",
	"./Cooladata.png": "160E",
	"./Coppermine.png": "1Zou",
	"./Copypoison.png": "U2Sr",
	"./Corebine.png": "MmiG",
	"./Correos.svg": "jymK",
	"./Cosmoshop.png": "8IBq",
	"./Cotonti.png": "k3kV",
	"./CouchDB.png": "EyfO",
	"./Countly.png": "Qxx+",
	"./Coureon.png": "obHB",
	"./Coveo.png": "q9gS",
	"./CoverManager.svg": "ztO4",
	"./Covet.pics.svg": "0Cgp",
	"./Cowboy.png": "flyk",
	"./Cozy AntiTheft.png": "LwcH",
	"./CppCMS.png": "CZ7d",
	"./Craft CMS.svg": "xukq",
	"./Cratejoy.png": "cyqu",
	"./Crazy Egg.png": "pNK1",
	"./CreateJS.svg": "WX0Z",
	"./Creativ.eMail.svg": "DAP8",
	"./Crisp Live Chat.svg": "5Lg5",
	"./Criteo.svg": "5QaL",
	"./Crobox.svg": "CFlU",
	"./Cross Pixel.png": "hIOy",
	"./CrossBox.png": "6qf8",
	"./CrossSell.png": "PxAM",
	"./CrownPeak.png": "C18x",
	"./Crownpeak.png": "IJKS",
	"./Cryout Creations.svg": "P6sC",
	"./Crypto-Loot.png": "inPy",
	"./CubeCart.png": "cB8M",
	"./Cubyn.svg": "R532",
	"./Cufon.png": "5Ke+",
	"./Custom Fonts.png": "F4aA",
	"./Customer.io.png": "v7KU",
	"./Customily.png": "pLQB",
	"./Cxense.png": "I+yC",
	"./CyberChimps.png": "glXG",
	"./Czater.svg": "ukEC",
	"./D3.png": "dc4N",
	"./DDoS-Guard.svg": "+OGI",
	"./DHL.svg": "mDcy",
	"./DHTMLX.png": "M2qk",
	"./DM Polopoly.png": "L5CL",
	"./DNN.png": "eYCH",
	"./DPD.svg": "G+aw",
	"./DPlayer.png": "3rKN",
	"./DTG.png": "904u",
	"./DTScout.png": "N0G6",
	"./DX.svg": "+ejy",
	"./Dachser.svg": "JGHT",
	"./Daily Deals.svg": "7PGA",
	"./DailyKarma.png": "cqhY",
	"./Dailymotion.svg": "1a4E",
	"./Dancer.png": "1d4w",
	"./Danneo CMS.png": "0kkh",
	"./Dart.svg": "qQFF",
	"./DataLife Engine.svg": "W3bM",
	"./DataMilk.svg": "iYSj",
	"./DataPower.png": "ujuY",
	"./DataTables.png": "Xfh/",
	"./Datadog.svg": "/yn9",
	"./DatoCMS.svg": "eRez",
	"./Day.js.svg": "gWP2",
	"./Dealer Spike.svg": "ZHmi",
	"./Debian.png": "jVH8",
	"./Decibel.svg": "F4FN",
	"./DedeCMS.png": "yMUz",
	"./Deliverr.svg": "GP5f",
	"./DerakCloud.png": "uYpu",
	"./Detectify.svg": "1WoE",
	"./Deutsche Post.svg": "HDAa",
	"./Devisto.svg": "iIbv",
	"./Dianomi.svg": "OXDK",
	"./DigiCert.svg": "C2zv",
	"./Digistore24.svg": "lKVD",
	"./Digital Factory.png": "IvDS",
	"./Digital Showroom.png": "oM6V",
	"./DigitalRiver.svg": "+/Xx",
	"./DirectAdmin.png": "GBzN",
	"./Directus.svg": "VQ1X",
	"./Discourse.png": "9qqj",
	"./Discuz X.png": "ydqa",
	"./Disqus.svg": "TGy3",
	"./District M.svg": "mjKZ",
	"./Dito.svg": "Jhjn",
	"./Divi.png": "yKW8",
	"./DivideBuy.png": "icH6",
	"./Divido.png": "4fVZ",
	"./Django CMS.png": "En7T",
	"./Django.png": "HZhZ",
	"./DocFX.svg": "b+BJ",
	"./Docker.svg": "Nfhd",
	"./DocuSign.svg": "M8Q2",
	"./Dojo.png": "7cyx",
	"./Dokan.svg": "48fr",
	"./Dokeos.png": "HYYb",
	"./DokuWiki.png": "pLeP",
	"./DomainFactory.png": "Vp3t",
	"./Dominate.png": "1eFT",
	"./Doofinder.svg": "zZcs",
	"./Dotclear.png": "J3j2",
	"./Dotdigital.svg": "Pj+u",
	"./DoubleClick.svg": "yoEd",
	"./DoubleVerify.svg": "SKJi",
	"./Dovetale.png": "gPht",
	"./Doxygen.png": "yjNL",
	"./Draftpress.png": "6XNS",
	"./Dragon.png": "3lup",
	"./Drapr.png": "Qs+f",
	"./DreamHost.svg": "2P/O",
	"./DreamWeaver.png": "RJYd",
	"./Dreamdata.png": "VtVU",
	"./Drift.svg": "3eVV",
	"./Drip.svg": "tlUk",
	"./Drop A Hint.png": "0Eaf",
	"./DropInBlog.png": "+xAu",
	"./Dropbox.svg": "211/",
	"./Dropzone.svg": "U93G",
	"./Droxit.png": "TKUi",
	"./Droz.svg": "Ze2q",
	"./Drupal Commerce.png": "h/Lr",
	"./Drupal.svg": "IhK7",
	"./Duel.svg": "n+TY",
	"./Dukaan.svg": "Oir5",
	"./Duopana.svg": "qnWs",
	"./DynamicYield.svg": "Ghgr",
	"./Dynamicweb.svg": "5Ywm",
	"./Dynatrace.png": "wdtc",
	"./Dynatrace.svg": "jW24",
	"./Dyte.svg": "mE77",
	"./EC-CUBE.svg": "4hNk",
	"./EKM.png": "O0WP",
	"./ELOG.png": "ILXX",
	"./EPiServer.png": "UVKt",
	"./EPrints.png": "N65E",
	"./ERPNext.png": "uq79",
	"./ESW.svg": "LURX",
	"./EWWW Image Optimizer.png": "joit",
	"./EX.CO.svg": "qO/r",
	"./Easy Hide PayPal.png": "jCpF",
	"./Easy Redirects.png": "oqf6",
	"./EasyDigitalDownloads.svg": "5p3P",
	"./EasyEngine.png": "znHX",
	"./EasyStore.svg": "v8gC",
	"./Ebasnet.svg": "HdKh",
	"./Ecovium.svg": "iCuc",
	"./EdgeCast.png": "gnw9",
	"./Edgio.svg": "fHDR",
	"./Editor.js.png": "JuFI",
	"./Eggplant.svg": "3fB8",
	"./ElasticAPM.png": "DV0J",
	"./ElasticSuite.svg": "BcL0",
	"./Elasticsearch.svg": "SlOK",
	"./Elcodi.png": "wKmf",
	"./Eleanor CMS.png": "JzHl",
	"./ElementUI.svg": "uBrv",
	"./Elementor Header & Footer Builder.svg": "gjyb",
	"./Elementor.png": "VWpP",
	"./Elevar.svg": "gUZ/",
	"./Eleventy.svg": "XdT4",
	"./Elfsight.svg": "BcLZ",
	"./Emarsys.svg": "8kGl",
	"./Ematic Solutions.svg": "iK2T",
	"./EmbedPlus.png": "GIAn",
	"./EmbedSocial.svg": "hE7B",
	"./Embedly.svg": "b1a4",
	"./Embedthis.png": "46TQ",
	"./Ember.js.png": "J8PY",
	"./Emotion.png": "WR7h",
	"./Emotive.svg": "igd1",
	"./Enable.png": "i/5x",
	"./Engagio.png": "QRha",
	"./Enjin.svg": "gYrj",
	"./Enlistly.png": "DzZ8",
	"./Ensi.png": "8QHr",
	"./Envialia.png": "OH/f",
	"./Envo Themes.png": "Q1Q/",
	"./Envoy.png": "JYze",
	"./Envybox.svg": "igXr",
	"./Enyo.png": "y9/g",
	"./Epom.png": "mjqE",
	"./EqualWeb.png": "KZHM",
	"./EraofEcom.png": "XHT8",
	"./Erlang.png": "GC0J",
	"./Errorception.png": "iD/s",
	"./Essent.png": "eQVM",
	"./Essential Addons for Elementor.svg": "MwRa",
	"./EstoreCompare.svg": "fv6C",
	"./EstoreShopserve.svg": "b41E",
	"./Ethers.svg": "njZ7",
	"./EthicalAds.svg": "ch04",
	"./Etix.svg": "aa+g",
	"./Etracker.png": "CDE6",
	"./Etsy.svg": "QsoG",
	"./Everflow.png": "ixOy",
	"./Eveve.svg": "Mc27",
	"./Evidon.png": "PnlM",
	"./ExactMetrics.svg": "0iu+",
	"./Exemptify.png": "mIMN",
	"./Exhibit.png": "CdX1",
	"./ExitIntel.png": "+Da0",
	"./ExoClick.png": "9/rm",
	"./ExpertRec.png": "34Jm",
	"./Exponea.svg": "Dk8A",
	"./Express.png": "ozDX",
	"./ExpressionEngine.svg": "d5Uz",
	"./ExtJS.png": "3oIa",
	"./ExtendThemes.svg": "C3rj",
	"./Extendify.svg": "lP/M",
	"./Extole.png": "0SBx",
	"./Ezoic.svg": "czAl",
	"./F5.png": "GQaX",
	"./FAST ESP.png": "605f",
	"./FAST Search for SharePoint.png": "ud6Y",
	"./Fabric.svg": "2wpA",
	"./Facebook.svg": "OQI7",
	"./Facil-iti.svg": "634m",
	"./Fact Finder.png": "yy6X",
	"./FalguniThemes.png": "ldV8",
	"./FameThemes.svg": "vlW2",
	"./FancyBox.png": "Zz10",
	"./Fanplayr.svg": "9ibf",
	"./FaraPy.png": "AXBe",
	"./FareHarbor.svg": "SLyT",
	"./Farfetch.png": "/tpr",
	"./Fast Bundle.svg": "Z1ez",
	"./Fast Checkout.svg": "cwPg",
	"./FastComet.png": "tycw",
	"./Fastcommerce.png": "C5Rz",
	"./Fasterize.svg": "aB2I",
	"./Fastly.svg": "EzZB",
	"./Fat-Free Framework.png": "QQ1t",
	"./Fathom.svg": "z4yc",
	"./Fbits.png": "3csr",
	"./FeatherX.svg": "d4HA",
	"./FedEx.svg": "Ufmd",
	"./Fedora.png": "hXeh",
	"./Feefo.svg": "nAbp",
	"./Fenicio.svg": "wFlL",
	"./Fera.svg": "Xib1",
	"./Financeads.png": "UK3D",
	"./Findify.svg": "G3iw",
	"./Findmeashoe.png": "rhew",
	"./Fing.svg": "H1Em",
	"./FingerprintJS.svg": "Wk5M",
	"./FintechOS.svg": "yMyO",
	"./Firebase.png": "jc0D",
	"./Firebase.svg": "vsNI",
	"./Fireblade.png": "mlIf",
	"./Firepush.svg": "9tKS",
	"./FirstHive.svg": "FJ4Q",
	"./FirstImpression.io.png": "EF65",
	"./Fit Analytics.png": "sVLn",
	"./FlagSmith.svg": "zoZq",
	"./Flask.png": "KAEo",
	"./Flat UI.png": "lrkr",
	"./Flazio.svg": "oY6s",
	"./Fleksa.svg": "OFrs",
	"./FlexCMP.png": "vS3B",
	"./FlexSlider.png": "1Aov",
	"./Flits.png": "phT4",
	"./Flocktory.png": "uBs3",
	"./Flow.png": "PKq5",
	"./Flowbite.svg": "X3ak",
	"./Flowplayer.svg": "oJ2/",
	"./Flutter.svg": "9cXT",
	"./FluxBB.png": "TVsn",
	"./Fly.io.png": "Gdxv",
	"./Flyspray.png": "mDjI",
	"./Fomo.png": "4KVu",
	"./Fontify.png": "z5Y1",
	"./FooPlugins.svg": "GSXz",
	"./Food-Ordering.co.uk.png": "mXvp",
	"./FoodBooking.png": "f91J",
	"./Fork Awesome.png": "LNhV",
	"./ForkCMS.png": "U1eN",
	"./Formidable Form.png": "V7RT",
	"./Formitable.svg": "nCVR",
	"./ForoshGostar.svg": "oVwW",
	"./Forte.svg": "qbB6",
	"./Forter.svg": "0H1l",
	"./Fortune3.png": "0zVQ",
	"./Four.svg": "aUAQ",
	"./Foursixty.png": "9Sxx",
	"./Fourthwall.svg": "l0Dd",
	"./Framer Sites.svg": "fZLI",
	"./France Express.svg": "i4AG",
	"./Frappe.png": "nqvn",
	"./FreakOut.png": "BNJH",
	"./FreeBSD.png": "J9aq",
	"./FreeTextBox.png": "/DKU",
	"./Freespee.svg": "3xyb",
	"./Frequently Bought Together.png": "sBfN",
	"./Freshchat.svg": "R/rR",
	"./Freshop.png": "paBB",
	"./Freshteam.svg": "wbiI",
	"./Freshworks CRM.svg": "OBTv",
	"./Friendbuy.svg": "4HuX",
	"./FriendlyCaptcha.svg": "+hYW",
	"./Frizbit.png": "8Bve",
	"./Froala.svg": "6tws",
	"./FrontPage.png": "iGPb",
	"./Frontastic.png": "4LJd",
	"./Frontify.svg": "0pqb",
	"./Frosmo.png": "fCPf",
	"./FullContact.svg": "zBQ0",
	"./FullStory.svg": "ZiqZ",
	"./Fundiin.svg": "Ac6C",
	"./Fusion Ads.png": "GvFR",
	"./Futurio.png": "hYGu",
	"./Fynd Platform.png": "uBhO",
	"./G-WAN.png": "16ec",
	"./GEODIS.svg": "HGmx",
	"./GEOvendas.svg": "246w",
	"./GLS.svg": "PKG7",
	"./GTranslate.svg": "lLkc",
	"./GX WebManager.png": "/N5v",
	"./Gallery.png": "6fux",
	"./Gambio.png": "rlII",
	"./Gameball.svg": "0nC4",
	"./Gatsby.svg": "n//H",
	"./Gauges.png": "2ym8",
	"./GemPages.svg": "ks8n",
	"./Gemius.png": "Iidv",
	"./GeneXus.png": "RXMX",
	"./Genesis theme.svg": "MU1z",
	"./Genesys Cloud.svg": "fhyO",
	"./Geniee.png": "E8qz",
	"./Gentoo.png": "5Dyn",
	"./Geo Targetly.svg": "mnei",
	"./Get Satisfaction.png": "sbe2",
	"./GetButton.svg": "7vus",
	"./GetFeedback.svg": "l7ry",
	"./GetMeAShop.png": "aVoh",
	"./GetResponse.svg": "bbOX",
	"./GetSimple CMS.png": "Z4OS",
	"./GetSocial.png": "XSi2",
	"./GetYourGuide.svg": "eUui",
	"./Getintent.png": "0/0o",
	"./Getsitecontrol.svg": "1FiG",
	"./Ghost.png": "RFDl",
	"./Gist.svg": "LklN",
	"./GitBook.png": "ubN4",
	"./GitHub.svg": "/C/h",
	"./GitLab CI.png": "fbXU",
	"./GitLab.svg": "+KhK",
	"./GiveWP.svg": "jhJd",
	"./Gladly.png": "lC2j",
	"./GlassFish.png": "BvJ8",
	"./Glassbox.svg": "h0ha",
	"./Glider.js.svg": "OjM0",
	"./Glitch.svg": "JicN",
	"./Global-e.svg": "Xhm5",
	"./GlobalShopex.png": "7ZNR",
	"./Globale.png": "wix8",
	"./Globo apps.png": "pNm2",
	"./Glopal.png": "EyUh",
	"./Glyphicons.png": "VUwS",
	"./Go Instore.svg": "YA74",
	"./Go.svg": "SIa2",
	"./GoAhead.png": "PnlV",
	"./GoCache.png": "I7Xc",
	"./GoCertify.png": "Phlg",
	"./GoDaddy.svg": "ZI11",
	"./GoJS.png": "pb18",
	"./GoKwik.svg": "AN5o",
	"./GoStats.png": "1QRX",
	"./Goftino.svg": "jMVJ",
	"./Google AdSense.svg": "kxep",
	"./Google Ads.svg": "r9ZX",
	"./Google Analytics.svg": "+dO5",
	"./Google App Engine.svg": "vMvr",
	"./Google Charts.png": "OCDs",
	"./Google Developers.svg": "tF0z",
	"./Google Font API.png": "7Z7d",
	"./Google Maps.svg": "qZEN",
	"./Google Optimize.svg": "t4um",
	"./Google PageSpeed.svg": "BTxm",
	"./Google Plus.svg": "QDNh",
	"./Google Publisher Tag.svg": "9KI+",
	"./Google Sites.png": "Gfr7",
	"./Google Tag Manager for WordPress.png": "TzIN",
	"./Google Tag Manager.svg": "YPHs",
	"./Google Wallet.png": "4T1z",
	"./Google Web Toolkit.png": "2eQ3",
	"./Google Workspace.svg": "x2HP",
	"./Google.svg": "PXdN",
	"./Gorgias.png": "cI2a",
	"./GotiPath.png": "i/5s",
	"./Govalo.svg": "5gf0",
	"./Grab.svg": "jEvb",
	"./Grafana.svg": "+dk+",
	"./Graffiti CMS.png": "w5iT",
	"./GrandNode.svg": "OGpV",
	"./GraphCMS.svg": "cZtH",
	"./GraphQL.svg": "hYz6",
	"./Graphene Themes.png": "4PLK",
	"./Grav.png": "Dilc",
	"./Gravatar.png": "cOer",
	"./Gravitec.png": "sHje",
	"./Green Valley CMS.png": "qokd",
	"./Greenhouse.svg": "OJSl",
	"./Griddo.svg": "Pr5d",
	"./Gridsome.svg": "0Sgv",
	"./Grin.png": "p3i4",
	"./GrocerKey.png": "I1uk",
	"./Groupby.svg": "zBFN",
	"./Growave.svg": "FHxM",
	"./GrowingIO.png": "/huy",
	"./Guestonline.svg": "3PTC",
	"./GumGum.png": "UcoJ",
	"./Gumlet.png": "mypH",
	"./Gumroad.svg": "A1QA",
	"./Gumstack.svg": "0J11",
	"./Gutenberg Blocks.png": "rs+D",
	"./Gutenberg.png": "0N/e",
	"./HCL Commerce.svg": "0coc",
	"./HHVM.png": "6eGx",
	"./HP.svg": "E/Nx",
	"./HTTP2.svg": "zYXd",
	"./HTTP3.svg": "IhWP",
	"./Halo.png": "/IVY",
	"./Hamechio.svg": "l93F",
	"./Hammer.js.png": "SY3J",
	"./Handlebars.png": "Cjyy",
	"./Handtalk.png": "zHBS",
	"./Hansel.png": "DHsQ",
	"./Happy Returns.png": "DFq5",
	"./HappyFox.svg": "rhiw",
	"./Haptik.png": "s0e7",
	"./Haravan.png": "fM9d",
	"./Haravan.svg": "nGJy",
	"./HashThemes.png": "OLM2",
	"./Haskell.png": "Ne+d",
	"./HeadJS.png": "EH8o",
	"./Headless UI.svg": "J9xC",
	"./Heap.svg": "e+56",
	"./Heartland Payment Systems.svg": "GJSF",
	"./Helhost.svg": "3VB4",
	"./HelixUltimate.svg": "0yC5",
	"./Helixo.svg": "LK3B",
	"./Hello Bar.png": "R67T",
	"./Hello Elementor.png": "jMsM",
	"./Help Scout.svg": "UjlL",
	"./HelpDocs.svg": "brXQ",
	"./Helpscout.svg": "geb5",
	"./Hermes.svg": "mHBv",
	"./Hero.png": "j+IQ",
	"./HetrixTools.png": "uY10",
	"./Hetzner.svg": "xMhV",
	"./Hexo.png": "2uim",
	"./Hextom.png": "RDRD",
	"./HiConversion.png": "PvLR",
	"./Hiawatha.png": "iExG",
	"./Highcharts.png": "0tPN",
	"./Highlight.js.png": "7W7f",
	"./Highstreet.png": "9O04",
	"./HikeOrders.png": "dQQG",
	"./Hireology.png": "C9Ho",
	"./Histats.png": "bsVg",
	"./Hoefler&Co.svg": "VJ9Y",
	"./Hogan.js.png": "xjjX",
	"./Homerr.svg": "BSnH",
	"./Homestead.png": "xiV6",
	"./HostEurope.png": "0RuM",
	"./Hostens.svg": "7N5z",
	"./Hostgator.svg": "WmQX",
	"./Hosting Ukraine.png": "RG3Z",
	"./Hostinger.svg": "lYBs",
	"./Hostiq.png": "Pgfn",
	"./Hostmeapp.svg": "iLqe",
	"./Hostpoint.svg": "BSTi",
	"./Hotaru CMS.png": "K+6R",
	"./Hotjar.svg": "INUd",
	"./Howler.js.svg": "Qagb",
	"./HrFlow.ai.svg": "YwOW",
	"./HubSpot.png": "likv",
	"./Huberway.svg": "Dg1M",
	"./Hugo.png": "Y9bP",
	"./Hugo.svg": "rbW7",
	"./HulkApps.svg": "zspL",
	"./Humm.svg": "2uRJ",
	"./Hund.io.svg": "3mIi",
	"./Hushly.png": "fRSM",
	"./Hyperspeed.png": "zrW1",
	"./Hypervisual.png": "fYqi",
	"./Hypestyle CSS.png": "wkaA",
	"./Hyva.svg": "xwxB",
	"./IBM.svg": "+8h4",
	"./IIS.png": "teTW",
	"./INFOnline.png": "iZjF",
	"./IONOS.svg": "M2iF",
	"./IPB.png": "gyW2",
	"./IPFS.png": "ZTzs",
	"./IPInfoDB.png": "DaL1",
	"./IPinfo.svg": "bVi1",
	"./Iamport.png": "oz1U",
	"./Ideasoft.png": "5nsB",
	"./Identrust.svg": "WaKG",
	"./Iluria.png": "6hnE",
	"./Image Relay.svg": "qGFJ",
	"./ImageEngine.svg": "6VOL",
	"./Imagely.png": "nwGz",
	"./Imber.png": "hmqu",
	"./Immutable.js.png": "Q5og",
	"./Impact.svg": "eOgO",
	"./Imperva.svg": "L2W0",
	"./ImpressCMS.png": "2anU",
	"./ImpressPages.png": "uiLd",
	"./Imweb.png": "tdre",
	"./In Cart Upsell & Cross-Sell.png": "WWIv",
	"./InMoment.svg": "8NfS",
	"./InSyncai.png": "BNQH",
	"./Incapsula.png": "iiKj",
	"./Includable.svg": "mQTz",
	"./Index Exchange.svg": "zEbW",
	"./Indi.png": "Sm6W",
	"./Indico.png": "nmjg",
	"./Inertia.svg": "/TDG",
	"./InfernoJS.png": "DbyI",
	"./Infogram.svg": "XXeU",
	"./Infolinks.png": "Dy0T",
	"./Infomaniak.svg": "hx7h",
	"./Insider.svg": "xx2Q",
	"./Instabot.png": "DCZL",
	"./Instafeed.png": "GE+S",
	"./Instana.svg": "Xdux",
	"./Instant.page.svg": "GI0M",
	"./InstantCMS.png": "LRKk",
	"./InstantClick.svg": "XgI+",
	"./InstantGeo.svg": "Q4nV",
	"./Instapage.svg": "86kz",
	"./Instatus.svg": "XmEC",
	"./Integral Ad Science.svg": "iXrW",
	"./Intel Active Management Technology.png": "3sNZ",
	"./IntenseDebate.png": "6f+S",
	"./Interact.svg": "hI5h",
	"./Intercom.svg": "FGyx",
	"./Intershop.png": "X4Or",
	"./Invenio.png": "Qc+c",
	"./Inventrue.svg": "3vQ+",
	"./Inveon.svg": "K5rq",
	"./Invoca.svg": "w2tj",
	"./Ionicons.png": "hXb6",
	"./Ionos-by-1and1-logo.svg": "GDFf",
	"./IrisLMS.png": "9d6e",
	"./Isotope.svg": "U+RF",
	"./Issuu.svg": "kx9D",
	"./Iterable.png": "11fn",
	"./Izooto.png": "xoTv",
	"./JANet.png": "FC0w",
	"./JAlbum.png": "WT3l",
	"./JBoss Application Server.png": "InHY",
	"./JBoss Web.png": "daON",
	"./JET Enterprise.svg": "0Nuj",
	"./JS Charts.png": "4TuC",
	"./JSEcoin.png": "eddj",
	"./JSS.png": "tR/B",
	"./JShop.svg": "qNa4",
	"./JTL Shop.png": "SUgY",
	"./JTL Shop.svg": "MURL",
	"./JW Player.svg": "SSN8",
	"./JahiaDX.svg": "9vIf",
	"./Jalios.png": "5gMQ",
	"./Java.png": "S/C8",
	"./JavaScript Infovis Toolkit.png": "axne",
	"./JavaServer Faces.png": "FRkb",
	"./Jekyll.png": "IC6E",
	"./Jenkins.png": "gjUD",
	"./Jetpack.svg": "Dw59",
	"./Jetshop.png": "eR+9",
	"./Jetty.png": "IPJ7",
	"./Jibres.svg": "5sm5",
	"./Jimdo.svg": "eVe9",
	"./Jirafe.png": "tsfs",
	"./Jitsi.png": "EZ93",
	"./Jive.png": "nm4N",
	"./JivoChat.png": "Cq0E",
	"./Jivox.svg": "oTWP",
	"./JobAdder.png": "Y9tS",
	"./JobberBase.png": "+MYz",
	"./Jobvite.png": "NHfC",
	"./JoomShopping.png": "ZXF6",
	"./Joomla.svg": "MrCN",
	"./JouwWeb.svg": "YGVo",
	"./JsObservable.svg": "gmQ5",
	"./JsRender.svg": "LyMm",
	"./JsViews.svg": "+Axj",
	"./Judge.svg": "Dg5Q",
	"./JuicyAds.png": "atXS",
	"./Jumbo.png": "bduS",
	"./Jumio.svg": "Xbhw",
	"./Jumpseller.svg": "h9/+",
	"./Junip.svg": "ZwX9",
	"./Juo.svg": "n6qT",
	"./Justo.svg": "t4Cq",
	"./Justuno.png": "8XPQ",
	"./K2.png": "XQaz",
	"./KISSmetrics.png": "uWxw",
	"./KMK.svg": "rd5C",
	"./KQS.store.png": "xkZj",
	"./KaTeX.svg": "fQWr",
	"./Kadence WP.svg": "Wogm",
	"./Kaira.png": "vavO",
	"./Kajabi.svg": "UNh6",
	"./Kakao.svg": "sZM1",
	"./Kaltura.svg": "1n+H",
	"./Kameleoon.svg": "Mxz1",
	"./Kampyle.png": "Tp5i",
	"./Kamva.svg": "J3Rg",
	"./Kapture CRM.png": "wqJ0",
	"./Karma.svg": "jZeZ",
	"./Kartra.png": "OR4I",
	"./Keap.svg": "OXIm",
	"./Keen Delivery.svg": "YoCf",
	"./Kendo UI.png": "7hOt",
	"./Kentico CMS.png": "idga",
	"./Keptify.png": "Selk",
	"./Kevel.svg": "fic4",
	"./KeyCDN.png": "jG+y",
	"./Kibo.png": "OCl7",
	"./KineticJS.png": "Ypk6",
	"./Kirki Customizer Framework.png": "hovG",
	"./Kitcart.png": "9LYn",
	"./Kiwi Sizing.png": "UVu1",
	"./Klarna.svg": "nB4+",
	"./Klaro.png": "BlgL",
	"./Klasha.svg": "I1VA",
	"./Klaviyo.svg": "fsDY",
	"./Klevu.png": "TvV+",
	"./Klickly.svg": "3qPu",
	"./Knockout.js.png": "d6Ek",
	"./Ko-fi.svg": "j47t",
	"./Koa.png": "oaAc",
	"./Koala Framework.png": "xuQy",
	"./Kobimaster.png": "ZA+X",
	"./Kohana.png": "8+g0",
	"./Koken.png": "wiVK",
	"./Komodo CMS.png": "PWRq",
	"./Konduto.png": "bmLq",
	"./Koobi.png": "WmGG",
	"./Kooboo CMS.png": "0QuY",
	"./Kooomo.svg": "UjsU",
	"./Kotisivukone.png": "whOw",
	"./Kount.svg": "4LHc",
	"./Kubernetes.svg": "iDcf",
	"./KueskiPay.svg": "oJQy",
	"./Kustomer.svg": "VL3x",
	"./LEPTON.png": "N0P4",
	"./LINE.svg": "d9/v",
	"./LKQD.svg": "A+Dn",
	"./LOU.png": "VLvp",
	"./La Poste.svg": "bFZp",
	"./Lagoon.png": "Jq/8",
	"./LangShop.svg": "PBrN",
	"./Laravel.svg": "uqWS",
	"./LatitudePay.svg": "Hy21",
	"./LaunchDarkly.svg": "haW8",
	"./Launchrock.svg": "J+vv",
	"./LayBuy.svg": "X3Oc",
	"./Layer0.svg": "Vf4L",
	"./LayoutHub.png": "B6dk",
	"./Lazada.svg": "XF9y",
	"./Leadinfo.svg": "lMsM",
	"./Leaflet platform.png": "iP+O",
	"./Leaflet.png": "tHqn",
	"./Leanplum.svg": "3aka",
	"./LearnWorlds.svg": "un5V",
	"./Leaseweb.svg": "ugD8",
	"./Legal Monster.svg": "WBSG",
	"./Less.png": "CFN1",
	"./Letro.svg": "KuBt",
	"./Lets Encrypt.svg": "qV4j",
	"./Level 5.png": "99rr",
	"./Lever.svg": "luju",
	"./Lieferando.svg": "6laf",
	"./Liferay.svg": "VVtZ",
	"./Lift.png": "7Ooe",
	"./LightMon Engine.png": "b7o1",
	"./Lightbox.png": "d6Sj",
	"./Lightning.png": "dUrD",
	"./Lightspeed.svg": "SlAV",
	"./LimeChat.png": "xCVL",
	"./LimeSpot.png": "D6FH",
	"./Limepay.svg": "hxph",
	"./Limit Login Attempts Reloaded.png": "HcPS",
	"./LinkSmart.png": "Hif2",
	"./Linkedin.svg": "x1Up",
	"./Linx.png": "zm+Q",
	"./Liquid Web.svg": "MPmj",
	"./List.js.png": "utYf",
	"./Listrak.png": "OtjE",
	"./Lit.svg": "EjAa",
	"./LiteSpeed.svg": "ekM8",
	"./Lithium.png": "5XMS",
	"./Littledata.svg": "Q4ue",
	"./LiveAgent.png": "ojMM",
	"./LiveChat.png": "LJQD",
	"./LiveHelp.png": "uJmp",
	"./LiveIntent.svg": "Okr7",
	"./LiveJournal.png": "2o0Y",
	"./LivePerson.png": "+Vrc",
	"./LiveRamp.svg": "gO7H",
	"./LiveSession.svg": "fTJf",
	"./LiveStory.png": "Kluh",
	"./LiveStreet CMS.png": "J3eB",
	"./LiveZilla.png": "AhmD",
	"./Livefyre.png": "RG1G",
	"./Liveinternet.png": "vDfm",
	"./Livescale.png": "1Ii9",
	"./Livewire.png": "3177",
	"./Livewire.svg": "SnuW",
	"./Lo-dash.png": "4UUk",
	"./Loadable-Components.png": "pFdh",
	"./Loadify.png": "cgpo",
	"./LocalFocus.png": "ETmV",
	"./Localised.png": "SOFw",
	"./Locksmith.png": "DJHF",
	"./LocomotiveCMS.png": "8dud",
	"./LogRocket.svg": "zRyd",
	"./Loggly.svg": "FXK8",
	"./LogiCommerce.svg": "2Wac",
	"./LoginRadius.svg": "1AiX",
	"./LogoiX.png": "rWdh",
	"./Loja Integrada.png": "nt4m",
	"./Loja Mestre.svg": "ue0k",
	"./Loja Virtual.svg": "yNwo",
	"./Loja2.svg": "li0C",
	"./Loop.svg": "jOtM",
	"./Loop54.png": "xD8V",
	"./Lootly.png": "8Poe",
	"./Loox.svg": "wyqt",
	"./Loqate.svg": "cL1M",
	"./LottieFiles.svg": "Pa8s",
	"./Lotus Domino.png": "hYHH",
	"./LoyaltyLion.svg": "+n3r",
	"./Lua.png": "EmML",
	"./Luana.png": "KXVj",
	"./Lucene.png": "IgNL",
	"./Lucky Orange.svg": "d7Le",
	"./Luigisbox.svg": "HM9W",
	"./Luna.svg": "39rh",
	"./LyraThemes.png": "REt8",
	"./Lytics.svg": "82Sb",
	"./MAAK.png": "vjHp",
	"./MAJIN.png": "FexA",
	"./MDUI.png": "jMLC",
	"./MGID.png": "hvIx",
	"./MGPanel.png": "VvCi",
	"./MIYN.svg": "WEuC",
	"./MODX.png": "AeTV",
	"./MRW.png": "ZPjC",
	"./MTCaptcha.png": "Ks5M",
	"./MUI.svg": "r5Ck",
	"./Macaron.png": "u1Vd",
	"./MachoThemes.png": "c6ZL",
	"./MadAdsMedia.png": "TRNd",
	"./Magazord.svg": "XeLS",
	"./MageWorx.svg": "Kulv",
	"./Magento.svg": "1jfD",
	"./Magisto.png": "U+4h",
	"./MailChimp for WordPress.png": "tEzr",
	"./MailerLite.svg": "+UjQ",
	"./Mailgun.svg": "1qdB",
	"./Mailjet.svg": "vgf3",
	"./Mailman.svg": "g7ky",
	"./Mailmunch.svg": "vg26",
	"./MainAd.svg": "2OYp",
	"./Make-Sense.png": "h43d",
	"./MakeShop.svg": "mbhK",
	"./MakeShopKorea.png": "SQh8",
	"./Malomo.svg": "sPxY",
	"./Mambo.png": "pFWb",
	"./Mangeznotez.svg": "cshr",
	"./MantisBT.png": "Utzq",
	"./ManyChat.svg": "vDnS",
	"./ManyContacts.png": "teyr",
	"./Mapbogljs.png": "q8zK",
	"./Mapbox.svg": "WT2k",
	"./Mapp.svg": "NhKr",
	"./Mapplic.svg": "EBkG",
	"./Maptalks.png": "NROI",
	"./Marchex.png": "9SyF",
	"./Marfeel.svg": "nHme",
	"./Marionette.js.svg": "U0p0",
	"./Marker.svg": "77tp",
	"./Marketo.png": "xDUa",
	"./Marko.svg": "dLvW",
	"./Mastercard.svg": "zk4/",
	"./Masterking32.png": "2e/h",
	"./Mastodon.svg": "M7SL",
	"./Matajer.png": "e0bN",
	"./Material Design Lite.png": "dOKZ",
	"./Materialize CSS.png": "8bfF",
	"./MathJax.png": "jdRw",
	"./Matomo.png": "Snck",
	"./MaxCDN.png": "W606",
	"./MaxMind.png": "DZcI",
	"./MaxSite CMS.png": "PcJa",
	"./Maxemail.svg": "ZoCw",
	"./Measured.svg": "XnVw",
	"./Medallia.svg": "hxcM",
	"./Media.net.svg": "VEjA",
	"./MediaElement.js.png": "Epvw",
	"./MediaWiki.png": "Xhkt",
	"./MediaWiki.svg": "Gk7v",
	"./Mediavine.svg": "CHQH",
	"./Medium.svg": "e6Vh",
	"./Meebo.png": "7WGS",
	"./Meeting Scheduler.png": "yIRq",
	"./Megagroup.svg": "/SEW",
	"./MemberStack.png": "5UYD",
	"./Mention Me.png": "aHA+",
	"./Menufy.png": "Ymnc",
	"./Mercado Shops.svg": "+jFd",
	"./MetaSlider.svg": "GKKL",
	"./Meteor.png": "MWoR",
	"./Methode.png": "UqtK",
	"./Metrilo.svg": "2yc2",
	"./Mews.png": "5C9L",
	"./Microsoft 365.svg": "XKEP",
	"./Microsoft ASP.NET.png": "7NLF",
	"./Microsoft ASP.NET.svg": "TDPR",
	"./Microsoft Excel.svg": "8IxK",
	"./Microsoft PowerPoint.svg": "4JP1",
	"./Microsoft Publisher.svg": "Dlbi",
	"./Microsoft SharePoint.png": "LDvB",
	"./Microsoft Word.svg": "0mNN",
	"./Microsoft.png": "YZVI",
	"./Microsoft.svg": "OGtP",
	"./Miestro.svg": "+6je",
	"./Milestone.svg": "pldJ",
	"./Milligram.png": "Uic8",
	"./MinMaxify.png": "mt38",
	"./MindBody.svg": "V163",
	"./Mindbox.png": "3zYN",
	"./Mint.png": "FwUY",
	"./Miresoone.svg": "HV0Z",
	"./Misskey.svg": "EaEc",
	"./Mittwald.svg": "MJsw",
	"./Mixin.svg": "4oJY",
	"./Mixpanel.png": "C4Ni",
	"./MizbanCloud.svg": "iU8o",
	"./MoEngage.png": "0e6d",
	"./Moat.svg": "8KhG",
	"./MobX.svg": "aubP",
	"./Mobicred.png": "w2jb",
	"./Mobify.png": "tpn9",
	"./MochiKit.png": "3iU7",
	"./Modern Campus.png": "aeH4",
	"./Modernizr.svg": "T727",
	"./ModiFace.svg": "8HAd",
	"./Module Federation.png": "tZj4",
	"./Moguta.CMS.png": "Uok2",
	"./MoinMoin.png": "eADN",
	"./Mojolicious.png": "mzj5",
	"./Mokka.svg": "RWin",
	"./Mollom.png": "/Rxt",
	"./Moment.js.svg": "yUit",
	"./Mondial Relay.svg": "jKap",
	"./Mondo Media.png": "u2kX",
	"./Moneris.svg": "NvqA",
	"./MongoDB.png": "/NYd",
	"./Mongrel.png": "gh0J",
	"./Monkey HTTP Server.png": "vBr7",
	"./Mono.net.png": "+tCL",
	"./Mono.png": "WHxY",
	"./Monsido.png": "035N",
	"./MonsterInsights.png": "NIjS",
	"./MooTools.png": "qg4T",
	"./Moodle.png": "qXnF",
	"./Moove.svg": "Ni89",
	"./Mopinion.svg": "Ikvk",
	"./Moshimo.png": "If26",
	"./MotoCMS.svg": "b+Im",
	"./Movable Ink.png": "N1Kb",
	"./Movable Type.svg": "HwyG",
	"./Mozard Suite.png": "jDAI",
	"./Mulberry.svg": "3gaT",
	"./Mura CMS.png": "5NTq",
	"./Mustache.png": "c8Qp",
	"./Muuri.svg": "Ei2O",
	"./My Flying Box.svg": "OL62",
	"./My Food Link.svg": "OBlW",
	"./MyBB.png": "efEg",
	"./MyBlogLog.png": "LSLA",
	"./MyFonts.svg": "JqyQ",
	"./MyLiveChat.png": "74WC",
	"./MyOnlineStore.png": "mpmr",
	"./MySQL.svg": "yk53",
	"./MyWebsite.svg": "KeFH",
	"./Myhkw player.png": "ngaP",
	"./Mynetcap.png": "6UIK",
	"./MysteryThemes.png": "9gxZ",
	"./NACEX.svg": "RKnG",
	"./NSW Design System.svg": "VkwC",
	"./NVD3.png": "n41F",
	"./Nacelle.svg": "eH1C",
	"./NagaCommerce.svg": "DeeZ",
	"./Nagich.svg": "I75R",
	"./NagishLi.png": "auQX",
	"./Najva.png": "Sdyw",
	"./Narrativ.png": "OnOR",
	"./Narvar.svg": "hM1w",
	"./NationBuilder.svg": "D+9h",
	"./Nativo.png": "c3Z4",
	"./Navegg.png": "DyPl",
	"./Naver.svg": "zJgW",
	"./Neat.png": "boM+",
	"./Neos.svg": "W8Q5",
	"./Nestify.png": "seOf",
	"./NetSuite.png": "JXTE",
	"./Netlify.svg": "ZTei",
	"./Neto.svg": "yUsA",
	"./Nette Framework.png": "7SuC",
	"./New Relic.svg": "RvBB",
	"./NewStore.png": "GxPm",
	"./NewspackLogo.png": "l8m7",
	"./Nexive.svg": "cT1/",
	"./Next Total.svg": "o3gZ",
	"./NextGEN Gallery.png": "OCDC",
	"./Nextdoor Ads.png": "cg2d",
	"./Nextsale.svg": "bCXN",
	"./Nginx.svg": "XzYw",
	"./Niagahoster.svg": "FUYD",
	"./Nicepage.png": "83Pj",
	"./Nift.png": "55C+",
	"./Ninja Forms.svg": "0UIK",
	"./NitroPack.svg": "DMNB",
	"./NoFraud.svg": "wGYH",
	"./Noddus.png": "TUmL",
	"./NodeBB.png": "TW6K",
	"./Norton Shopping Guarantee.svg": "1A8c",
	"./Nosto.svg": "pxGq",
	"./Notion.svg": "D6Zr",
	"./Nudgify.svg": "PeNf",
	"./Nukeviet CMS.png": "JDfH",
	"./Nuqlium.png": "v2If",
	"./Nuvemshop.svg": "zF5Z",
	"./Nuxt.js.svg": "1SA5",
	"./OVHcloud.svg": "BEsN",
	"./OWL Carousel.png": "4s+M",
	"./OXID eShop.svg": "veQe",
	"./Obsidian.png": "MkUl",
	"./Obviyo.png": "ZgDs",
	"./Occasion.png": "rJbL",
	"./OceanWP.png": "XUjB",
	"./Ochanoko.svg": "Ihdn",
	"./Oct8ne.png": "vB94",
	"./Octane AI.svg": "jW/x",
	"./October CMS.png": "cmcB",
	"./Ocuco.png": "VVvB",
	"./Odoo.png": "YEnp",
	"./Oh Dear.svg": "eY8t",
	"./Okendo.svg": "WMGW",
	"./Okta.svg": "CgrG",
	"./Olapic.svg": "wRAa",
	"./Olark.png": "Lm2Y",
	"./Ometria.svg": "+oS0",
	"./Omise.svg": "vE9F",
	"./Omniconvert.png": "cxw4",
	"./Omnisend.svg": "CvIU",
	"./Omny Studio.svg": "0+VO",
	"./Omurga Sistemi.svg": "Z9z0",
	"./OnUniverse.png": "9Ls/",
	"./One.com.svg": "wzRS",
	"./OneAPM.png": "ipGE",
	"./OneAll.png": "4TP4",
	"./OnePress Social Locker.png": "A92t",
	"./OneSignal.svg": "vFta",
	"./OneStat.png": "m6mJ",
	"./OneTrust.png": "llf+",
	"./Oney.svg": "ZkES",
	"./Onfido.svg": "1ECP",
	"./Onshop.svg": "KCsJ",
	"./Ookla.svg": "DErD",
	"./Oopy.png": "ImVj",
	"./Open AdStream.svg": "Xj7P",
	"./Open Classifieds.png": "49hf",
	"./Open Graph.png": "lxp9",
	"./Open Journal Systems.png": "Genk",
	"./Open Web Analytics.png": "Z/zc",
	"./Open eShop.png": "mG7U",
	"./OpenBSD httpd.svg": "Jdcu",
	"./OpenCart.png": "9hmJ",
	"./OpenCms.png": "53oN",
	"./OpenElement.png": "Cy11",
	"./OpenGrok.png": "XMzc",
	"./OpenLayers.png": "T9zh",
	"./OpenNemas.png": "zZlH",
	"./OpenResty.png": "IaVd",
	"./OpenSSL.png": "rpma",
	"./OpenStreetMap.svg": "lrR+",
	"./OpenTable.svg": "g6BD",
	"./OpenText Web Solutions.png": "5lYB",
	"./OpenUI5.png": "9AKu",
	"./OpenWeb.svg": "D7Sm",
	"./OpenX.png": "Vcyt",
	"./OpinionLab.png": "vmEY",
	"./OptiMonk.svg": "Dmu0",
	"./Optimise.svg": "cJYo",
	"./Optimizely.svg": "pqs4",
	"./Optimove.svg": "EkhV",
	"./OptinMonster.png": "plWM",
	"./Oracle.png": "MNMg",
	"./Oracle.svg": "WRWW",
	"./Orankl.png": "zJ1S",
	"./OrbitFox.svg": "RPXe",
	"./Orchard CMS.png": "lGTH",
	"./Orckestra.svg": "HJEl",
	"./Order Deadline.png": "2TQ8",
	"./OrderLogic app.png": "1y6C",
	"./OrderYOYO.png": "rvtC",
	"./Ordersify.svg": "XzMM",
	"./Oribi.svg": "0ywI",
	"./Osano.svg": "o1f5",
	"./OutSystems.svg": "/xwS",
	"./OutTheBoxThemes.png": "arAg",
	"./Outbrain.png": "NRNO",
	"./Outbrain.svg": "8TM2",
	"./Outlook.svg": "UmRC",
	"./Oxatis.svg": "euYd",
	"./OxiSocialLogin.png": "Bjum",
	"./Oxygen.png": "CX7T",
	"./PCRecruiter.png": "Sbki",
	"./PDF.js.svg": "sZcb",
	"./PHP-Nuke.png": "quxU",
	"./PHP.svg": "Zg/l",
	"./PHPFusion.png": "74J1",
	"./PIXIjs.svg": "aN+O",
	"./POLi Payment.svg": "jD0i",
	"./POWR.svg": "M41P",
	"./PWA Studio.png": "2gG5",
	"./PWA.svg": "JH/h",
	"./Pace.svg": "4dea",
	"./Packlink.png": "s/3Y",
	"./Paddle.svg": "kEmE",
	"./PagSeguro.svg": "YddR",
	"./Pagar.me.svg": "Zx9q",
	"./Page Builder Framework.png": "3CVi",
	"./Pagekit.png": "XJwb",
	"./Pagevamp.png": "+xVD",
	"./Paidy.png": "bXPr",
	"./Paloma.svg": "Z/FP",
	"./Paradox.svg": "n2bh",
	"./Parcel.png": "Po9m",
	"./Parcelforce.svg": "ZoCO",
	"./Pardot.png": "GkBt",
	"./ParkingCrew.png": "Y0RV",
	"./Parse.ly.png": "6kvm",
	"./Partially.png": "LnQG",
	"./Partnerize.png": "s5+w",
	"./Parttrap.png": "gcr3",
	"./Partytown.png": "V7lM",
	"./Patreon.svg": "GWEn",
	"./Pay It Later.png": "gl/p",
	"./PayBright.png": "Vons",
	"./PayJustNow.svg": "NYuK",
	"./PayKickStart.png": "Gtqe",
	"./PayPal.svg": "TWlH",
	"./Payfast.svg": "DtrR",
	"./Payflex.png": "Vd8m",
	"./Payl8r.svg": "veiJ",
	"./Paylocity.svg": "XJSE",
	"./PebblePost.svg": "t2Qc",
	"./Peek.svg": "aYvy",
	"./PeerBoard.png": "6/0O",
	"./PeerTube.svg": "8NOt",
	"./PencilBlue.png": "/8hJ",
	"./Pendo.svg": "H2X7",
	"./Pepperjam.png": "HIki",
	"./Percussion.png": "ZKJT",
	"./PerfectApps Swift.png": "DQgi",
	"./Perfex CRM.png": "f4gh",
	"./Performance Lab.svg": "AC9q",
	"./Periodic.svg": "6att",
	"./Perl.png": "PbOe",
	"./Permutive.png": "QYiW",
	"./PersonaClick.png": "D36i",
	"./Personio.svg": "58EJ",
	"./Personizely.svg": "Vmen",
	"./Perzonalization.png": "n/pG",
	"./Phabricator.png": "6QJu",
	"./Phaser.png": "/qXv",
	"./Phenomic.svg": "LbVQ",
	"./Phlox.png": "gf6r",
	"./Phoenix Site.png": "L5Ve",
	"./Photo Gallery.svg": "uzz7",
	"./PhotoShelter.png": "Q68u",
	"./PhotoSwipe.png": "81gi",
	"./Photoslurp.svg": "pJp/",
	"./Phusion Passenger.png": "eKfA",
	"./Piano.png": "ruNd",
	"./PickyStory.png": "LH0d",
	"./Picreel.svg": "Dibw",
	"./Picturepark.svg": "s0BO",
	"./Pingdom.svg": "C+gm",
	"./Pingoteam.svg": "oJF0",
	"./Pinterest.svg": "wpqA",
	"./Pipedrive.svg": "lg1p",
	"./Piwik PRO Core.svg": "6nXQ",
	"./Pixc.svg": "WBdp",
	"./PixelFed.svg": "6TFq",
	"./PixelYourSite.png": "YsgA",
	"./Pixelee TurnTo.png": "UfBo",
	"./Pixieset.svg": "5ysA",
	"./Pixlee.png": "vq0I",
	"./Pixnet.svg": "C05l",
	"./PizzaNetz.png": "34xm",
	"./Planet.png": "pQSj",
	"./Plataforma NEO.svg": "Yke2",
	"./PlatformOS.svg": "xV6k",
	"./Plausible.svg": "XoQm",
	"./Play.svg": "MPXV",
	"./Plaza.svg": "9kUw",
	"./Pleroma.svg": "ADFa",
	"./Plesk.png": "e+XA",
	"./Pligg.svg": "PxV2",
	"./Plone.svg": "x6BK",
	"./Plotly.png": "gZ22",
	"./Plyr.png": "5Rl8",
	"./Po.st.png": "Y1MP",
	"./Podia.svg": "Jzam",
	"./Podigee.svg": "u200",
	"./Podium.png": "+2ZI",
	"./Podsights.png": "pQRf",
	"./Pojo.me.png": "KW1n",
	"./Poloriz.svg": "LX9g",
	"./Polylang.svg": "itAY",
	"./Polymer.png": "YOPJ",
	"./Popmenu.svg": "E4Ud",
	"./Popper.png": "aAlZ",
	"./Popper.svg": "CDRE",
	"./PopularFX.png": "W7nN",
	"./Popup Maker.png": "W8Y+",
	"./Post AG.svg": "ZWiZ",
	"./Post Affiliate Pro.svg": "YGbc",
	"./PostNL.svg": "z2VW",
	"./Poste Italiane.svg": "WeR+",
	"./Posterous.png": "Z6gD",
	"./PostgreSQL.png": "UAT5",
	"./Postpay.svg": "K6Bg",
	"./Postscript.svg": "d4FA",
	"./PowerReviews.png": "TXyP",
	"./Powergap.png": "4bAG",
	"./Preact.svg": "37Mk",
	"./Prebid.png": "Tnrq",
	"./Prediggo.png": "foaO",
	"./Prefix-Free.png": "jetc",
	"./Premio.png": "9xi5",
	"./Press.svg": "BJvh",
	"./PressMaximum.png": "EcDF",
	"./PrestaShop.svg": "Z+6w",
	"./Pretty Links.png": "ztwR",
	"./PriceSpider.png": "9ap8",
	"./Primis.svg": "SPEH",
	"./Printful.png": "VCaf",
	"./Prism.svg": "vRx/",
	"./Prismic.svg": "PfnR",
	"./Privy.svg": "+Nd1",
	"./ProcessWire.svg": "ScTu",
	"./Product Personalizer.png": "MIh8",
	"./ProfilePress.svg": "Y5al",
	"./Profitwell.svg": "rg1B",
	"./Project Wonderful.png": "1r6w",
	"./PromoBuilding.svg": "cwu9",
	"./Prototype.png": "xmy3",
	"./ProvenExpert.svg": "BDDw",
	"./Provide Support.svg": "8zbK",
	"./Proximis Omnichannel.png": "0vow",
	"./Pterodactyl Panel.svg": "lJvm",
	"./PubGuru.png": "uCq9",
	"./PubMatic.svg": "qci3",
	"./Public CMS.png": "Kx/w",
	"./PulseSecure.png": "BVRW",
	"./Pure CSS.png": "IdfV",
	"./Pure Chat.png": "o7gX",
	"./PureCars.png": "wJ/M",
	"./PurpleAds.svg": "CvO8",
	"./PushDaddy.png": "qYX7",
	"./PushEngage.png": "D7mj",
	"./PushOwl.svg": "kKZz",
	"./PushPushGo.svg": "8TSK",
	"./Pushnami.svg": "+4LK",
	"./PyroCMS.png": "kvvl",
	"./Python.png": "yEHG",
	"./Q4.png": "MNKY",
	"./Qikify.svg": "1mCn",
	"./Qstomizer.png": "PuP5",
	"./Qualaroo.svg": "M36M",
	"./Qualified.svg": "oOdP",
	"./Qualtrics.svg": "XqiE",
	"./Quanta.svg": "36Dt",
	"./Quantcast.png": "+aIt",
	"./Quantummetric.png": "aOGo",
	"./Quasar.svg": "cnP3",
	"./Qubit.png": "pLFv",
	"./Queue-it.png": "iF9N",
	"./Quick.CMS.png": "McdR",
	"./Quick.Cart.png": "CO/p",
	"./Quicklink.svg": "J0gi",
	"./Quicq.svg": "94JE",
	"./Quill.png": "hvww",
	"./Quora.svg": "x29R",
	"./Qwik.svg": "vZsF",
	"./RBS Change.png": "v2ir",
	"./RCMS.png": "Vhe/",
	"./RD Station.png": "C3qa",
	"./RDoc.png": "R6dF",
	"./REDAXO.png": "q/mj",
	"./REG.RU.svg": "phxn",
	"./RTB House.png": "CiV6",
	"./RXWeb.svg": "J2C+",
	"./RackCache.png": "6bdI",
	"./Rain.svg": "mqkE",
	"./RainLoop.png": "ddeU",
	"./Rakuten Advertising.svg": "1+KN",
	"./Rakuten.svg": "z3FC",
	"./RakutenDigitalCommerce.png": "psQM",
	"./Ramda.png": "XOyn",
	"./RankMath SEO.svg": "463v",
	"./Raphael.png": "X9FV",
	"./RapidSec.svg": "gegA",
	"./RapidSpike.svg": "30Sq",
	"./Raptor.png": "WMMd",
	"./Raspbian.svg": "jKrV",
	"./RateParity.svg": "Lg6J",
	"./Raygun.svg": "ClZU",
	"./Rayo.png": "zs7Q",
	"./Razorpay.svg": "LgIr",
	"./Re-amaze.png": "RIuJ",
	"./ReCaptcha v2 for Contact Form 7.svg": "UAVi",
	"./ReConvert.svg": "SG8/",
	"./React Bricks.svg": "/b4r",
	"./React Router.png": "69is",
	"./React.png": "toWI",
	"./React.svg": "dPwc",
	"./Reactive.svg": "A08u",
	"./Really Simple CAPTCHA.png": "6Ny8",
	"./RebelMouse.svg": "MiRC",
	"./Rebuy.png": "kf+E",
	"./Recapture.png": "bo0M",
	"./Recart.svg": "mWtz",
	"./Recent Posts Widget With Thumbnails.png": "V/M8",
	"./Recharge.svg": "QOmo",
	"./Recite Me.png": "iqsq",
	"./Recomify.png": "Ye2Y",
	"./RecoverMyCart.png": "d60B",
	"./Recruitee.svg": "/m7r",
	"./Recurly.png": "5qMV",
	"./Red Hat.svg": "TSlP",
	"./Red je Pakketje.svg": "tLUc",
	"./RedCart.svg": "S4MK",
	"./Reddit.png": "zhDd",
	"./Redis.svg": "Lt2E",
	"./RedisObjectCache.svg": "2PSJ",
	"./Redmine.png": "KFlU",
	"./Redonner.svg": "/dOe",
	"./Redux.png": "30qa",
	"./RedwoodJS.svg": "q33+",
	"./Reelevant.svg": "alj1",
	"./Reevoo.svg": "RIG7",
	"./ReferralCandy.svg": "5Kmm",
	"./Refersion.svg": "cXaC",
	"./Reflektion.png": "8UQH",
	"./Refundid.png": "uwDC",
	"./Regiondo.svg": "ctTy",
	"./Reinvigorate.png": "B6qG",
	"./Relais Colis.png": "Zz9y",
	"./Remarkable.png": "G0Di",
	"./Remix.svg": "JAtQ",
	"./Reputon.svg": "0rrB",
	"./RequireJS.png": "hXt4",
	"./ResDiary.svg": "7BND",
	"./Resengo.svg": "GDnf",
	"./Reservio.svg": "jnuZ",
	"./Resin.png": "GieO",
	"./Resmio.svg": "VBT5",
	"./ResponsiveVoice.png": "5SY7",
	"./Resy.svg": "4mPj",
	"./Retail Rocket.png": "QQZz",
	"./ReturnGO.png": "WrfQ",
	"./Returnly.svg": "7ptb",
	"./RevJet.png": "clCq",
	"./RevLifter.png": "ixPm",
	"./Reveal.js.png": "zLsH",
	"./Revel.png": "ZPk2",
	"./RevenueHunt.png": "AlU8",
	"./RevenueHut.png": "Alx+",
	"./Revieve.svg": "YrjI",
	"./ReviewSolicitors.svg": "3Kre",
	"./Reviews.io.svg": "sVQX",
	"./RevolverMaps.svg": "7ZCo",
	"./Revy.png": "vqsy",
	"./Rewardful.svg": "hxBl",
	"./Rezdy.svg": "8a6g",
	"./Rezgo.svg": "6rl2",
	"./RichRelevance.png": "w2qF",
	"./Richpanel.svg": "aNcZ",
	"./RightJS.png": "h28Q",
	"./Riot.png": "Eiw6",
	"./Rise.ai.svg": "P0M6",
	"./Riskified.svg": "eZAg",
	"./RiteCMS.png": "tT7Q",
	"./Rive.svg": "GszP",
	"./Roadiz CMS.png": "F6w+",
	"./Robin.png": "XruE",
	"./RockRMS.svg": "kBrJ",
	"./Rockerbox.png": "yYJ1",
	"./Rocket.Chat.svg": "nQ71",
	"./Rokt.svg": "flF3",
	"./Rollbar.svg": "C5Hk",
	"./Rotic.png": "vbad",
	"./Rotic.svg": "lgJ1",
	"./RoundCube.png": "i5sx",
	"./Royal Mail.png": "7+ie",
	"./Rubicon Project.svg": "bO46",
	"./Ruby Receptionists.svg": "oYKy",
	"./Ruby on Rails.png": "P7/y",
	"./Ruby.png": "MOmD",
	"./Rudderstack.png": "ImRG",
	"./Rumble.svg": "KajF",
	"./Rust.svg": "km3K",
	"./RxJS.png": "vY4d",
	"./Ryviu.png": "QJZQ",
	"./SALESmanago.svg": "0p9R",
	"./SAP.svg": "u3K4",
	"./SDL Tridion.svg": "FAx6",
	"./SEMrush.svg": "LhtK",
	"./SEOmatic.svg": "2A+F",
	"./SHE Media.png": "VyP+",
	"./SIMsite.png": "jejb",
	"./SMF.png": "jd5r",
	"./SOBI 2.png": "mviC",
	"./SPDY.png": "5+7N",
	"./SQL Buddy.png": "+VPC",
	"./SQLite.png": "Bd3J",
	"./STN Video.png": "spQ8",
	"./STUDIO.svg": "V4On",
	"./SUSE.png": "Z5N8",
	"./SVG Support.png": "DAfR",
	"./SWFObject.png": "nlK1",
	"./SaaSquatch.svg": "Z75W",
	"./Saba.Host.png": "9aoo",
	"./SabaVision.png": "JXe9",
	"./Saber.svg": "hss7",
	"./Sails.js.svg": "Otz0",
	"./Sailthru.svg": "bFOH",
	"./Sakura Internet.png": "qsyj",
	"./Saleor.svg": "iQwi",
	"./SalesFire.svg": "bunP",
	"./SalesReps.io.png": "e3J2",
	"./Salesforce.svg": "k6Bu",
	"./Salla.svg": "1NUn",
	"./Salonist.png": "KFcS",
	"./Salsify.svg": "qq/z",
	"./Saly.svg": "wxwi",
	"./Sana Commerce.svg": "W8On",
	"./Sanity.svg": "lDVr",
	"./Sapper.svg": "T8IY",
	"./Sapren.png": "P3gH",
	"./Sarka-SPIP.png": "kbKw",
	"./Sass.svg": "y8J9",
	"./Satori Studio.svg": "rJ5V",
	"./Satori.png": "Xqkk",
	"./Sazito.svg": "mreH",
	"./Scala.png": "dTIH",
	"./Scalapay.svg": "qV90",
	"./Scalefast.svg": "f7xQ",
	"./Schedule Engine.svg": "clwv",
	"./Scientific Linux.png": "0kPn",
	"./Scissor Themes.png": "k6fd",
	"./Scoop.it.svg": "qI+A",
	"./Scorpion.svg": "0jDj",
	"./ScrollMagic.png": "9EqB",
	"./Scully.svg": "cFZ5",
	"./SeQura.svg": "4mnz",
	"./Seal Subscriptions.png": "ITuk",
	"./SeamlessCMS.png": "aWEE",
	"./SearchFit.svg": "pJ4M",
	"./Searchanise.svg": "iSVa",
	"./Searchspring.svg": "TndH",
	"./Secomapp.png": "emf+",
	"./Sectigo.svg": "YYYS",
	"./Sections-Design.png": "8CuL",
	"./SeedProd.svg": "6dff",
	"./Segmanta.png": "Ddsm",
	"./Segment.svg": "8jzt",
	"./SegmentStream.svg": "poSO",
	"./Select2.png": "PuRz",
	"./Sellacious.png": "7Ti9",
	"./Sellfy.svg": "mMeg",
	"./Sellingo.svg": "2f3x",
	"./Sellix.svg": "f91U",
	"./Sellsy.svg": "+ONX",
	"./Selly.svg": "ajG/",
	"./Selz.png": "gYYY",
	"./Semantic-ui.png": "bhA9",
	"./Sematext.svg": "l4AD",
	"./Semplice.svg": "rbO+",
	"./Sencha Touch.png": "UjGe",
	"./SendGrid.svg": "X9ck",
	"./Sendinblue.svg": "40UW",
	"./Sensors Data.svg": "pSFu",
	"./Sentry.svg": "RUee",
	"./Seravo.svg": "Fukk",
	"./Serendipity.png": "bUXU",
	"./Service Management Group.png": "FpXR",
	"./Service Provider Pro.svg": "cihm",
	"./ServiceNow.svg": "5PNz",
	"./Setmore.svg": "Mn3Z",
	"./SevenRooms.svg": "RExF",
	"./Sezzle.svg": "4U6Y",
	"./Shaka Player.png": "u3uh",
	"./Shanon.svg": "AiDk",
	"./Shapecss.svg": "2LOU",
	"./ShareThis.png": "uvgQ",
	"./Sharethrough.svg": "PjAq",
	"./Sharetribe.svg": "wbAm",
	"./SharpSpring.png": "Xwxk",
	"./SheerID.png": "mHE3",
	"./ShellInABox.png": "vE31",
	"./Shiny.png": "8X1E",
	"./ShinyStat.png": "Eelo",
	"./ShipTection.png": "AFwS",
	"./ShippyPro.png": "roUc",
	"./Shogun.svg": "TTAE",
	"./Shop Pay.svg": "UT1u",
	"./ShopGold.svg": "jk9H",
	"./ShopPad.svg": "cIhC",
	"./ShopWired.svg": "aHGk",
	"./Shopaholic.svg": "USgk",
	"./Shopapps.png": "eFQs",
	"./Shopatron.png": "OiRq",
	"./Shopcada.png": "kqiH",
	"./Shoper.svg": "KxEG",
	"./Shopery.svg": "/7+U",
	"./Shopfa.svg": "W7XJ",
	"./Shopify Geolocation App.png": "SSNN",
	"./Shopify.svg": "vrT1",
	"./Shopistry.png": "a+Hy",
	"./Shopline.svg": "6xu8",
	"./Shoplo.svg": "pEfC",
	"./Shoporama.svg": "kpOK",
	"./Shoppiko.png": "KAUA",
	"./ShoppingFeeder.png": "xtlE",
	"./ShoppingGives.png": "V1X5",
	"./Shoppy.svg": "OEPX",
	"./Shoprenter.svg": "hbOd",
	"./Shoprunner.png": "6908",
	"./Shoptet.svg": "ax4M",
	"./Shopware.svg": "LXz2",
	"./ShortPixel.svg": "OZtL",
	"./Shortcodes Ultimate.svg": "6vdl",
	"./Shortly.png": "l4Nm",
	"./ShoutOut.png": "PKRk",
	"./Sift.png": "VKK/",
	"./Signifyd.svg": "vX+H",
	"./SilverStripe.svg": "Zd+v",
	"./Simon.svg": "drdD",
	"./Simpl.svg": "4wPK",
	"./Simple Analytics.svg": "Az9E",
	"./Simplebo.png": "lsrG",
	"./Simplero.svg": "w+kK",
	"./Simplifi.png": "l5YV",
	"./Simplio Upsells.png": "AVzg",
	"./Simplo7.svg": "93Uq",
	"./Simvoly.png": "/Xeb",
	"./Sinatra.png": "ZB56",
	"./Sirclo.svg": "UVCo",
	"./Sirdata.svg": "+A43",
	"./Site Meter.png": "7OtP",
	"./Site Search 360.svg": "vd3Z",
	"./Site24x7.png": "43Yw",
	"./SiteEdit.png": "gteP",
	"./SiteGuard WP Plugin.png": "xn8j",
	"./SiteJabber.svg": "S/7Q",
	"./SiteManager.svg": "aiq5",
	"./SiteMinder.svg": "Jggh",
	"./SiteOrigin.svg": "Bf6n",
	"./SitePad.png": "42G+",
	"./SiteSpect.png": "lQga",
	"./SiteVibes.png": "2C4F",
	"./SiteW.svg": "4oos",
	"./Sitecore.png": "ZjLD",
	"./Sitecore.svg": "dLOX",
	"./Sitefinity.svg": "Aw54",
	"./Siteglide.svg": "Bm/t",
	"./Sitevision CMS.png": "6LET",
	"./Sivuviidakko.png": "HRtl",
	"./Sizmek.png": "LehG",
	"./Skai.svg": "SmbQ",
	"./Skedify.svg": "CPYf",
	"./Skimlinks.svg": "eaMh",
	"./Skio.png": "nbJ5",
	"./Sky-Shop.svg": "Ce9t",
	"./SkyVerge.svg": "ldxJ",
	"./Slice.svg": "H7Jy",
	"./SlickStack.png": "5Tue",
	"./Slider Revolution.svg": "mlUq",
	"./Slimbox 2.png": "97qI",
	"./Slimbox.png": "eTTu",
	"./Smart Ad Server.png": "cjnX",
	"./Smart Ad Server.svg": "k1C9",
	"./Smart Slider 3.svg": "WV2W",
	"./SmartRecruiters.png": "04hG",
	"./SmartSite.png": "OQeZ",
	"./SmartWeb.png": "VjmG",
	"./Smarter Click.png": "ijm9",
	"./Smartling.svg": "FHh7",
	"./Smartlook.svg": "PQ9U",
	"./Smartstore.biz.png": "HC1j",
	"./Smartstore.png": "MUTY",
	"./Smartsupp.svg": "eNGx",
	"./Smash Balloon.svg": "7n8y",
	"./Smile.svg": "TQqI",
	"./Smsbump.png": "UrAc",
	"./SmugMug.svg": "fw/b",
	"./Snap Pixel.svg": "Aucw",
	"./Snap.png": "PjQu",
	"./Snap.svg.png": "1HiT",
	"./Snap.svg.svg": "ov5X",
	"./SnapEngage.svg": "+0R7",
	"./SnapWidget.svg": "EGqR",
	"./Snipcart.png": "JZyV",
	"./Snipcart.svg": "Zv6L",
	"./SniperFast.png": "rFcj",
	"./Sniply.svg": "UQUc",
	"./Snoobi.png": "MmnO",
	"./Snowplow.svg": "z8AV",
	"./SobiPro.png": "UAjV",
	"./Social9.svg": "YhgN",
	"./SocialLadder.png": "EKrN",
	"./Socket.IO.svg": "ATE2",
	"./Soisy.png": "XbS0",
	"./SolidPixels.png": "deVB",
	"./Solodev.png": "Ac/S",
	"./Solr.png": "ueBP",
	"./Solusquare.png": "P6Ai",
	"./Solve Media.png": "Rv9h",
	"./Solvemate.svg": "HBVw",
	"./Sonobi.png": "jIPP",
	"./Sortable.png": "keWM",
	"./Sorted.svg": "f5ze",
	"./SoteShop.svg": "xm2o",
	"./Sotel.png": "VOix",
	"./Sotoon.svg": "UXMq",
	"./SoundCloud.svg": "zr20",
	"./SoundManager.png": "3BY+",
	"./Sovrn.png": "ZHmK",
	"./SparkPost.svg": "66nL",
	"./Speed Kit.svg": "197S",
	"./SpeedCurve.svg": "JHth",
	"./SpeedSize.svg": "feke",
	"./Speedimize.svg": "aw3w",
	"./Speedkit.svg": "Fvxl",
	"./Sphinx.png": "sIC8",
	"./SpiceThemes.png": "qaHO",
	"./Spin-a-Sale.png": "xWDb",
	"./SpinCMS.png": "la++",
	"./Spinnakr.png": "Z4K2",
	"./Split.png": "fqoH",
	"./SplitIt.svg": "JOYZ",
	"./SplittyPay.png": "fG//",
	"./Splunk.png": "1bWe",
	"./Splunk.svg": "Bn5d",
	"./SpotHopper.png": "xmjq",
	"./SpotX.png": "/r7/",
	"./Spotify.svg": "To9H",
	"./Spotii.svg": "EsML",
	"./Spree.png": "EVg6",
	"./Sprig.png": "pUDY",
	"./Spring for creators.svg": "w257",
	"./Spring.png": "23nk",
	"./Spryker.svg": "+PBh",
	"./SpurIT.svg": "ECR8",
	"./Sqreen.png": "FgT4",
	"./Squadded.png": "QhPR",
	"./Square.svg": "YpfT",
	"./Squarespace.png": "mOmY",
	"./Squarespace.svg": "sqDb",
	"./SquirrelMail.png": "A/b3",
	"./Squiz Matrix.png": "mpHj",
	"./Stack Analytix.svg": "Cs4V",
	"./StackPath.svg": "s+fH",
	"./Stackcommerce.png": "tqm1",
	"./StackerHQ.svg": "E8BF",
	"./Stackify.svg": "pGAe",
	"./Stackla.png": "k2p/",
	"./Stage Try.svg": "WZAl",
	"./Stamped.svg": "2ttW",
	"./Starhost.svg": "wGCH",
	"./Starlet.png": "QmQB",
	"./Statamic.svg": "bSvi",
	"./Statcounter.svg": "BIUg",
	"./Statically.svg": "ou23",
	"./SteelHouse.png": "HC77",
	"./Stencil.svg": "Gnb6",
	"./Stimulus.png": "/ox3",
	"./Stitches.svg": "SA8X",
	"./Store Systems.png": "WRB9",
	"./StoreHippo.png": "zgoI",
	"./Storefront UI.svg": "MNqF",
	"./StorifyMe.png": "MNyf",
	"./StoryStream.png": "qaiv",
	"./Storyblok.svg": "AU5M",
	"./Strapi.png": "6iGt",
	"./Strapi.svg": "ICq7",
	"./Strato.svg": "osvN",
	"./Strikingly.png": "8qld",
	"./Stripe.svg": "qfk6",
	"./StrutFit.svg": "tXCH",
	"./Stylitics.svg": "Xb62",
	"./Sub2Tech.png": "UV0G",
	"./Subbly.svg": "gYDV",
	"./Sublime.svg": "Jd4O",
	"./SublimeVideo.png": "kmhq",
	"./Subrion.png": "Nhz4",
	"./Substack.svg": "CFZG",
	"./Suiteshare.png": "pcZY",
	"./Sulu.svg": "d/rp",
	"./SummerCart.svg": "9O/m",
	"./Sumo.png": "axob",
	"./SumoMe.png": "jlTy",
	"./Super Builder.svg": "lLH0",
	"./Super Socializer.png": "Nm55",
	"./SuperLemon.png": "C2Ok",
	"./Supersized.png": "IdSY",
	"./Superspeed.png": "/fFf",
	"./Support Hero.png": "hu7V",
	"./Survicate.svg": "LUqV",
	"./Svelte.svg": "VbUc",
	"./Swagger UI.svg": "Og4D",
	"./Swagify.png": "xTW/",
	"./SweetAlert.png": "OC6k",
	"./SweetAlert2.png": "Tuqj",
	"./Swell.svg": "qZu3",
	"./Swiftlet.png": "E3D5",
	"./Swym.png": "9d7Y",
	"./Sylius.svg": "NSvL",
	"./Symfony.svg": "rICU",
	"./Syndeca.svg": "eaMR",
	"./Synerise.svg": "n2Yr",
	"./Synology DiskStation.svg": "BTP5",
	"./SyntaxHighlighter.png": "7wRz",
	"./Syte.svg": "oCtX",
	"./T1 Comercios.svg": "Quxm",
	"./T1 Envios.svg": "/MO2",
	"./T1 Paginas.svg": "TkO7",
	"./T1 Pagos.svg": "XG/h",
	"./TDesign.svg": "KijC",
	"./THG Ingenuity.png": "5Hcy",
	"./TRISOshop.svg": "cJ7t",
	"./TRUENDO.svg": "eXH8",
	"./TVSquared.png": "y9S9",
	"./TWiki.png": "YaPw",
	"./TYPO3.svg": "CAQ8",
	"./Tabarnapp.png": "ZjLm",
	"./Tabby.svg": "5+HD",
	"./TableBooker.svg": "PEOq",
	"./TableCheck.svg": "Bd6h",
	"./TablePress.png": "NWDt",
	"./Taboola.svg": "oIvk",
	"./Tada.png": "TbQZ",
	"./TagPro.png": "q+qk",
	"./Tagboard.svg": "Axlq",
	"./Taggbox.svg": "PxRH",
	"./Taiga.png": "Ull0",
	"./Tail.svg": "ONWu",
	"./TakeDrop.png": "Y1xg",
	"./Talkable.svg": "cckr",
	"./Tallentor.png": "sNcr",
	"./Tamago.png": "81zN",
	"./Tamara.svg": "WNNm",
	"./Tapad.svg": "jml/",
	"./Tapcart.svg": "fSzu",
	"./Target2Sell.png": "kBIs",
	"./Tatari.png": "VIDS",
	"./Tatari.svg": "fO9I",
	"./TawkTo.png": "c6ZE",
	"./Teachable.png": "Mf4L",
	"./Teads.svg": "RWB/",
	"./Tealeaf.png": "dCxT",
	"./Tealium.png": "yJU6",
	"./TeamCity.svg": "EvPR",
	"./Tebex.svg": "Ai52",
	"./Telescope.png": "A2W7",
	"./Tencent Cloud.svg": "VjuJ",
	"./Tencent QQ.svg": "OzKk",
	"./TencentWaterproofWall.png": "e/tn",
	"./Tengine.png": "ZnS/",
	"./TerriaJS.png": "/aVn",
	"./TestFreaks.svg": "Lz7y",
	"./Texthelp.svg": "9OT5",
	"./Textpattern CMS.png": "02Xm",
	"./The Arena Group.svg": "3MWy",
	"./The Events Calendar.png": "NbWU",
	"./The Hotels Network.svg": "WTwU",
	"./The SEO Framework.svg": "8/LV",
	"./The Theme Foundry.svg": "DEPX",
	"./The.com.svg": "BBxf",
	"./TheHutGroup.png": "Fa9m",
	"./Thefork.svg": "sjHM",
	"./Thelia.png": "F+X7",
	"./Theme Freesia.png": "QohW",
	"./Theme Horse.png": "cjWQ",
	"./Theme Vision.png": "SATd",
	"./Theme4Press.png": "O9jF",
	"./ThemeGrill.png": "fn2P",
	"./ThemeIsle.png": "lqxA",
	"./ThemeZee.png": "CUQm",
	"./Themeansar.png": "QqBB",
	"./Themebeez.png": "Qk3A",
	"./Themegraphy.png": "p003",
	"./Themes4Wp.png": "utD9",
	"./ThemezHut.png": "WbYX",
	"./Themonic.png": "0tCH",
	"./Thesis.svg": "0ccp",
	"./Thimatic.png": "L82I",
	"./Think Up Themes.png": "q/wP",
	"./ThinkPHP.png": "n3of",
	"./Thinkific.svg": "ix7p",
	"./Threekit.svg": "4ufU",
	"./ThriveCart.svg": "S51K",
	"./Ticimax.png": "96g0",
	"./TiddlyWiki.png": "PI/I",
	"./Tidio.svg": "UBv5",
	"./Tiendanube.svg": "ZcLR",
	"./TikTok.svg": "jEsC",
	"./Tiki Wiki CMS Groupware.png": "wFrj",
	"./Tilda.svg": "3BOc",
	"./Tiledesk.png": "4m+A",
	"./Timeplot.png": "FxOh",
	"./Timify.svg": "vA8pj",
	"./TinyMCE.png": "8YVx",
	"./Tippy.js.svg": "9UPo",
	"./Tipsa.svg": "L0uE",
	"./Tiqets.svg": "3G4S",
	"./Titan.png": "oxwG",
	"./TomTom.svg": "CbYs",
	"./TomatoCart.png": "nem2",
	"./TornadoServer.png": "W2ri",
	"./TotalCode.png": "NNqc",
	"./Totango.svg": "JLE2",
	"./Totara.svg": "HdkT",
	"./Touch2Success.svg": "Cztn",
	"./Trac.png": "Rk/T",
	"./TrackJs.svg": "imvg",
	"./Trackify X.png": "Umei",
	"./Tradedoubler.svg": "K5z6",
	"./TrafficStars.png": "mScX",
	"./Transcend.svg": "7TUY",
	"./Transcy.png": "RaPm",
	"./Trbo.svg": "iCie",
	"./Treasure Data.svg": "D1Kv",
	"./Trengo.svg": "sbCK",
	"./Tripadviser.Widget.svg": "C8/H",
	"./TripleLift.png": "rXz6",
	"./Tritac.svg": "3IZo",
	"./TruValidate.svg": "ma7L",
	"./True Fit.png": "N8G5",
	"./Truecommerce.svg": "gEy5",
	"./Trumba.png": "Vpt/",
	"./Trunkrs.svg": "tYFV",
	"./TrustArc.svg": "9JSJ",
	"./TrustYou.svg": "FVeI",
	"./Trusted Shops.svg": "dpCC",
	"./Trustindex.svg": "ayV8",
	"./Trustpilot.svg": "8BLL",
	"./Trustspot.png": "BTHu",
	"./Trustvox.png": "XZKm",
	"./Tsoft.png": "95ag",
	"./Tumblr.png": "GUOw",
	"./Turbo.svg": "I/hP",
	"./TurfJS.svg": "VZ5W",
	"./TurnTo.svg": "CwZ1",
	"./TweenMax.png": "Mz7g",
	"./TwicPics.svg": "SFDn",
	"./Twik.svg": "0hgv",
	"./Twilight CMS.png": "DRlN",
	"./TwistPHP.png": "dweV",
	"./TwistedWeb.png": "pQa4",
	"./Twitch.svg": "nslm",
	"./Twitter Flight.png": "AnjU",
	"./Twitter typeahead.js.png": "+nNd",
	"./Twitter.svg": "Emvw",
	"./TypeDoc.png": "Yko6",
	"./TypePad.png": "dHSe",
	"./TypeScript.svg": "Q9zd",
	"./Typeform.png": "aq3K",
	"./Typekit.png": "H2AK",
	"./Typof.png": "nk/T",
	"./Tyslo EasySell.png": "0kx/",
	"./U-KOMI.svg": "X/XX",
	"./UIKit.png": "EJOa",
	"./UK Mail.png": "8VAq",
	"./UKFast.png": "uwtv",
	"./UMI.CMS.png": "ZfSL",
	"./UNIX.png": "wRwH",
	"./UPS.svg": "Vike",
	"./USPS.svg": "zeCU",
	"./USWDS.svg": "bjZz",
	"./Ubercart.png": "WNuz",
	"./Ubuntu.png": "hWuc",
	"./Ueeshop.png": "pPEd",
	"./Ultimate GDPR & CCPA.png": "teaR",
	"./UltimatelySocial.png": "zbgR",
	"./UltraCart.png": "U0jG",
	"./Umbraco.png": "+xwR",
	"./UmiJs.png": "5pqG",
	"./Umso.svg": "fLD7",
	"./Unbounce.png": "pqu9",
	"./Unbxd.svg": "pNEi",
	"./Underscore.js.png": "hQBn",
	"./Understrap.png": "+mcK",
	"./Uniconsent.png": "y5Uu",
	"./Unicorn Platform.svg": "Nk5s",
	"./Unpkg.png": "bbmF",
	"./Unruly.png": "Aenv",
	"./UpSellit.png": "NFhr",
	"./Uploadcare.svg": "j2pl",
	"./Upptime.svg": "oFV6",
	"./Upserve.svg": "sbnq",
	"./UptimeRobot.svg": "ftqu",
	"./Uptrends.svg": "YiUt",
	"./Usabilla.svg": "ck06",
	"./UsableNet.png": "s/Jg",
	"./Uscreen.svg": "0bXN",
	"./User1st.png": "q187",
	"./UserLike.svg": "e8fH",
	"./UserReport.svg": "l3/G",
	"./UserRules.png": "Q9Hl",
	"./UserVoice.png": "/kVo",
	"./UserVoice.svg": "sij7",
	"./UserWay.png": "oUZ0",
	"./UserZoom.png": "uu1+",
	"./Usercentrics.svg": "NHwg",
	"./Userflow.svg": "I1tW",
	"./Userpilot.svg": "E5aW",
	"./Ushahidi.png": "Qteo",
	"./Usizy.svg": "VHh5",
	"./VAPTCHA.svg": "tJQn",
	"./VDX.tv.png": "ASHT",
	"./VIVVO.png": "9k/y",
	"./VP-ASP.png": "aBZx",
	"./VTEX.svg": "iQgA",
	"./VWO.svg": "Zuo/",
	"./Vaadin.svg": "8AHa",
	"./ValueCommerce.png": "A8LO",
	"./Vanilla.png": "ZM3l",
	"./Variti.png": "akRR",
	"./Varnish.svg": "4ZKy",
	"./Venmo.svg": "ZwL8",
	"./VentraIP.svg": "K+88",
	"./Veoxa.png": "v+jx",
	"./Verifone.svg": "RGc/",
	"./VerifyPass.png": "tqGl",
	"./Verizon Media.svg": "jWwV",
	"./Verloop.png": "QEWY",
	"./ViaBill.png": "7oPC",
	"./Vidazoo.svg": "69Ig",
	"./Video Greet.png": "yI3j",
	"./VideoJS.svg": "L3aa",
	"./VigLink.png": "dw+l",
	"./Vignette.png": "l8Fg",
	"./Vimeo.svg": "0eMy",
	"./Viral Loops.svg": "LMGk",
	"./Virgool.svg": "rRHZ",
	"./Virtooal.svg": "xCn4",
	"./VirtueMart.png": "BMWP",
	"./Virtusize.svg": "AvJm",
	"./Visa.svg": "SEpc",
	"./Visely.svg": "8DYV",
	"./Visual Quiz Builder.png": "KrW8",
	"./Visualsoft.svg": "h9Sg",
	"./Vitals.svg": "+N5L",
	"./Vitrin.me.svg": "bW9v",
	"./Vizury.png": "+vbn",
	"./Vntana.png": "x2A+",
	"./Volusion.svg": "YOiP",
	"./Vonage.svg": "la0B",
	"./Voog.png": "/Ewc",
	"./Voracio.svg": "vneG",
	"./VuFind.png": "bQt4",
	"./Vue.ai.svg": "Iv/u",
	"./VuePress.svg": "ppYR",
	"./Vuetify.svg": "/tPs",
	"./W3 Total Cache.png": "XQaj",
	"./W3C.png": "GrL2",
	"./W3Counter.png": "8A3v",
	"./WEBXPAY.png": "kaOd",
	"./WEN Themes.png": "fqxP",
	"./WHMCS.png": "ehfp",
	"./WP Fastest Cache.png": "W1UF",
	"./WP Google Map Plugin.png": "hEdk",
	"./WP Job Openings.svg": "/fhp",
	"./WP Maintenance Mode.png": "RqoO",
	"./WP Puzzle.svg": "JF4r",
	"./WP Rocket.png": "Rt/v",
	"./WP-Optimize.png": "Ksj0",
	"./WP-PageNavi.svg": "VCvx",
	"./WP-Royal.png": "lf1I",
	"./WP-Statistics.png": "IHbT",
	"./WP-Statistics.svg": "YD1h",
	"./WPCacheOn.png": "X9/N",
	"./WPForms.svg": "p+5i",
	"./WPMU DEV.png": "wAdK",
	"./Wagtail.svg": "kNP3",
	"./Wair.png": "IvUF",
	"./Wakav Performance Monitoring.png": "8Kta",
	"./WalkMe.svg": "T9Qc",
	"./Wangsu.png": "JVOd",
	"./Warp.png": "n6x6",
	"./Weaver Xtreme.png": "MZ+n",
	"./Web Shop Manager.png": "yWiK",
	"./Web-Stories.svg": "Il/n",
	"./Web2py.png": "U4QN",
	"./WebAssembly.svg": "RAG3",
	"./WebEngage.png": "GxaW",
	"./WebFactory.png": "Gy5U",
	"./WebGUI.png": "DzSS",
	"./WebHostUK.png": "3k1f",
	"./WebMetric.svg": "+lfS",
	"./WebNode.svg": "u+aM",
	"./WebRTC.svg": "UFRL",
	"./WebSite X5.png": "eZT2",
	"./WebToffee.svg": "Cu1O",
	"./Webgains.svg": "UnE+",
	"./Webix.png": "Ow2N",
	"./Weblication.svg": "dBXF",
	"./Weblium.svg": "9/of",
	"./Webmin.png": "YP9J",
	"./Webriti.png": "Lsqt",
	"./WebsPlanet.png": "7VtC",
	"./Websale.png": "88PS",
	"./WebsiteBaker.png": "Mjks",
	"./WebsiteCreator.png": "gFH3",
	"./Webtrekk.png": "9Hju",
	"./Webtrends.png": "SP9p",
	"./Webzi.svg": "z4hy",
	"./Webzie.svg": "bJqu",
	"./Weebly.svg": "PTjn",
	"./Weglot.png": "BHh0",
	"./Welcart.svg": "hItd",
	"./Whatfix.png": "k4FM",
	"./Whatfix.svg": "TPoR",
	"./WhatsApp.svg": "v8W0",
	"./Wheelio.png": "anZ1",
	"./Whistl.svg": "NgmT",
	"./Whooshkaa.svg": "zfVk",
	"./WideBundle.png": "h282",
	"./Widen.svg": "0S9t",
	"./WidgetWhats.png": "VED5",
	"./Wigzo.png": "L+8y",
	"./Wiki.js.png": "pbSD",
	"./WikkaWiki.png": "NP+z",
	"./WildJar.png": "JC/D",
	"./WindowsServer.png": "TT9t",
	"./Wink.png": "zTxe",
	"./Wirecard.svg": "h+d7",
	"./Wisepops.svg": "6y0Y",
	"./Wishlist King.png": "yD17",
	"./Wistia.svg": "gWjp",
	"./With Reach.svg": "3R5c",
	"./Wix Answers.svg": "TOz0",
	"./Wix.svg": "GpUX",
	"./WiziShop.png": "P6Cw",
	"./Wizpay.png": "Aj+i",
	"./Wolf CMS.png": "UJmH",
	"./Woltlab Community Framework.png": "LORa",
	"./WooCommerce Blocks.png": "+eEj",
	"./WooCommerce Multilingual.png": "4VIn",
	"./WooCommerce PayPal.png": "Y3La",
	"./WooCommerce Stripe Payment Gateway.png": "ZrkX",
	"./WooCommerce.svg": "y+l3",
	"./Woopra.png": "YRvL",
	"./Woostify.png": "sfMe",
	"./WoowUp.png": "NssR",
	"./WordAds.png": "Cvm2",
	"./WordPress.svg": "HqL+",
	"./Wordfence.svg": "g5D8",
	"./Workable.svg": "oBth",
	"./Workarea.png": "zUif",
	"./World4You.svg": "t6Zn",
	"./WorldPay.svg": "0vIU",
	"./Worldz.png": "IRcS",
	"./Wufoo.svg": "4FuY",
	"./Wuilt.png": "Xyxs",
	"./Wunderkind.svg": "NVJk",
	"./Wurfl.png": "F501",
	"./WysiBB.svg": "pHiE",
	"./X-Cart.png": "KrfQ",
	"./X.ai.png": "PPH9",
	"./XAMPP.png": "f3+r",
	"./XMB.png": "CA24",
	"./XOOPS.png": "0F3d",
	"./XRegExp.png": "XUxX",
	"./Xajax.png": "9qia",
	"./Xanario.png": "o9tf",
	"./XenForo.png": "DCRt",
	"./Xitami.png": "FVr9",
	"./XpressEngine.png": "o2FA",
	"./Xpresslane.png": "/ez6",
	"./Xserver.png": "7ZDw",
	"./Xtremepush.svg": "ZB2O",
	"./YMQ Product Options Variant Option.png": "+jWL",
	"./YNAP.png": "FlZP",
	"./YUI.png": "Wuqo",
	"./YaBB.png": "dxG7",
	"./Yahoo.svg": "sdfC",
	"./YalinHost.png": "Qt5C",
	"./Yampi.svg": "fV1x",
	"./Yandex.Cloud.svg": "oCjT",
	"./Yandex.Direct.png": "Llj8",
	"./Yandex.Messenger.svg": "GMMv",
	"./Yandex.Metrika.png": "Beri",
	"./Yaws.png": "V0EX",
	"./Yektanet.png": "hEWt",
	"./Yelp.svg": "osmh",
	"./Yett.png": "f2vj",
	"./Yext.svg": "awH/",
	"./Yieldify.svg": "3FkI",
	"./Yieldlab.png": "7Qtq",
	"./Yii.png": "clsf",
	"./Yoast SEO.png": "eorV",
	"./Yola.png": "Yayy",
	"./YooMoney.svg": "MVvt",
	"./Yotpo.svg": "vyAg",
	"./Yottaa.svg": "0LWf",
	"./YouCam Makeup.png": "t1fM",
	"./YouCan.svg": "rbeD",
	"./YouPay.svg": "nWo2",
	"./YouTrack.png": "KNS1",
	"./YouTube.png": "KJ52",
	"./ZK.png": "UXtZ",
	"./ZURB Foundation.png": "LK6V",
	"./Zabbix.png": "Daey",
	"./Zakeke.png": "nDOq",
	"./Zakra.png": "jZTz",
	"./Zanox.png": "ANcY",
	"./Zaraz.svg": "eXOv",
	"./Zen Cart.png": "mY+C",
	"./Zend.png": "dXi5",
	"./Zendesk Chat.png": "F5Yg",
	"./Zendesk.png": "+dOb",
	"./Zenfolio.png": "YdtA",
	"./Zeotap.png": "zboF",
	"./Zepto.png": "opat",
	"./ZestMoney.png": "TJxh",
	"./Zeus Technology.svg": "dY82",
	"./Zid.png": "LSDn",
	"./Zimbra.png": "RcJB",
	"./ZingChart.svg": "7XDI",
	"./Zinnia.png": "+J8B",
	"./Zinrelo.png": "636P",
	"./Zipify OCU.svg": "tek9",
	"./Zipify Pages.svg": "Yv4+",
	"./Zipkin.png": "nAnx",
	"./Zmags Creator.png": "9/yW",
	"./Zocdoc.svg": "cD7k",
	"./Zoey.svg": "B2DQ",
	"./Zoho.svg": "Agl8",
	"./Zoko.png": "HanG",
	"./Zonos.svg": "odRz",
	"./ZoodPay.png": "kCxJ",
	"./Zoominfo.svg": "CDHM",
	"./Zope.png": "/urX",
	"./Zozo.png": "mbY+",
	"./Zuppler.png": "0Kov",
	"./Zyro.svg": "64IN",
	"./a-blog cms.svg": "8jUg",
	"./a3.png": "l2Fn",
	"./aThemes.svg": "/h9Z",
	"./abicart.png": "og6J",
	"./acquia-campaign-factory.png": "F+NY",
	"./acquia-cdp.png": "w79+",
	"./acquia-cloud-ide.png": "REWr",
	"./acquia-cloud-platform.svg": "AJKh",
	"./acquia-cloud.png": "Ee0i",
	"./acquia-content-hub.png": "n7uH",
	"./acquia-personalization.png": "um/w",
	"./acquia-site-factory.png": "06mO",
	"./acquia-site-studio.png": "BkaF",
	"./actionhero.js.png": "Frme",
	"./addi.png": "OJsC",
	"./adminer.png": "YP63",
	"./adnegah.png": "eQJv",
	"./adobe_experience_platform.png": "0CVv",
	"./adobedtm.png": "FfyJ",
	"./after-buy.png": "46ow",
	"./afterpay.png": "7bcp",
	"./aircall.png": "smlO",
	"./akamai.svg": "GLzb",
	"./akaunting.svg": "qBQa",
	"./akinon.png": "g4l4",
	"./akka-http.png": "bgYK",
	"./all-in-One-SEO-Pack.png": "zMWR",
	"./amCharts.png": "sO50",
	"./amazon-efs.png": "e+w0",
	"./amber.png": "rND2",
	"./amex.png": "Onqd",
	"./amoCRM.svg": "FI6b",
	"./amplitude.png": "m9ov",
	"./anime.js.png": "QEzP",
	"./anime.js.svg": "JUSV",
	"./apigee.svg": "z0My",
	"./apostrophecms.svg": "yNgv",
	"./arcgis_icon.png": "Dyyi",
	"./asciinema.png": "6HoZ",
	"./aspnetboilerplate.png": "vQnU",
	"./astra.png": "UJc4",
	"./atome.png": "8Ykh",
	"./atws.png": "1UNi",
	"./augmented-ui.png": "Q1Ue",
	"./automattic.png": "EuJ3",
	"./aws-ec2.svg": "1+xj",
	"./aws-elb.png": "kTfT",
	"./aws-s3.svg": "Nte3",
	"./aws.svg": "1JeW",
	"./aws_aurora.png": "C53E",
	"./azure.svg": "gmTL",
	"./bSecure.svg": "nwDA",
	"./bablic.png": "lvka",
	"./basket.js.png": "YMWr",
	"./bigcartel.png": "hdU1",
	"./bizweb.png": "3vzK",
	"./bokeh.png": "DPf9",
	"./boom.svg": "Bg2h",
	"./boomerang.svg": "7xHP",
	"./borderfree.png": "//l+",
	"./bubble.png": "hRKc",
	"./cPanel.png": "dXEN",
	"./cState.svg": "GmWD",
	"./caddy.svg": "Vm8B",
	"./ccvshop.png": "X1XM",
	"./cdnjs.svg": "jXGh",
	"./cendyn.png": "cJxn",
	"./centminmod.png": "omW+",
	"./cgit.png": "bR4K",
	"./chevereto.png": "lkky",
	"./citruspay.png": "jNyk",
	"./civic.png": "I9qn",
	"./clarity.svg": "XL5y",
	"./classy.png": "RV7/",
	"./clickio.png": "Yxjy",
	"./cloudcart.svg": "6EFl",
	"./cnzz.png": "63C8",
	"./coaster-cms.png": "Bu7V",
	"./coinhave.png": "CdTf",
	"./coinimp.png": "ORKg",
	"./colormeshop.png": "AxFG",
	"./comScore.png": "YCTS",
	"./comScore.svg": "LdjW",
	"./commercejs.png": "qlbA",
	"./commercelayer.svg": "ywRE",
	"./commercetools.svg": "rsgD",
	"./cookieyes.svg": "Xu8z",
	"./core-js.png": "8oxN",
	"./cybersource.png": "3osP",
	"./daphne.svg": "rC+X",
	"./datadome.png": "wCGm",
	"./datocms.svg": "cW5r",
	"./db-ip.png": "cVQO",
	"./decimal.js.png": "LgcR",
	"./deepminer.png": "fa/Y",
	"./default.svg": "GQsG",
	"./demandbase.svg": "7vb/",
	"./deno.svg": "jYIw",
	"./deta.svg": "j7D1",
	"./didomi.png": "SPTz",
	"./distributor.svg": "bWIa",
	"./docusaurus.svg": "unuR",
	"./draftjs.png": "knjU",
	"./duda.png": "WdaA",
	"./e-goi.svg": "2CPE",
	"./e107.png": "TyT7",
	"./eBay.svg": "g7fY",
	"./eCaupo.png": "A40A",
	"./eClass.png": "JW++",
	"./eDokan.png": "eucg",
	"./eKomi.png": "GQft",
	"./ePages.svg": "QBwB",
	"./eSSENTIAL Accessibility.png": "VL3r",
	"./eShop eCommerce.svg": "Ud6+",
	"./eShopCRM.png": "/plo",
	"./eSyndiCat.png": "o3LT",
	"./eZ.svg": "mu4b",
	"./ebis.png": "FH+J",
	"./ec-cube.png": "IniL",
	"./echarts.png": "TyFv",
	"./ecwid.svg": "qBwp",
	"./ef.js.svg": "e1DT",
	"./elasticpress.svg": "73or",
	"./elm.svg": "CD0I",
	"./emBlue.svg": "gh2f",
	"./endurance-cache.png": "9XHK",
	"./enduro.js.svg": "6BQp",
	"./engintron.png": "PLBJ",
	"./ensighten.png": "F6OV",
	"./epages.png": "hOWy",
	"./etherpad.png": "JAwT",
	"./etika.svg": "Y4uT",
	"./eucookie.png": "kszB",
	"./eway.png": "m/jL",
	"./experiencedCMS_Logo.png": "6HAV",
	"./fastspring.png": "3y7S",
	"./fatzebra.png": "UD2L",
	"./feedback-fish.svg": "K4jP",
	"./filepond.svg": "BEL+",
	"./flarum.png": "fdKy",
	"./flow.png": "Y0N3",
	"./flywheel.svg": "Y3Sv",
	"./font-awesome.svg": "l/EO",
	"./foswiki.png": "utta",
	"./foxyio.svg": "4ru9",
	"./fresh.svg": "AhKM",
	"./frontity.png": "D3ap",
	"./fullPage.js.png": "oJ3b",
	"./futureshop.png": "9XN3",
	"./generatepress.png": "SXYl",
	"./gerrit.svg": "cQ/J",
	"./git.svg": "H+PT",
	"./gitea.svg": "eYTz",
	"./gluster.png": "Rea6",
	"./goaffpro.svg": "Hi9a",
	"./goanywhere.png": "3Dz5",
	"./goatcounter.svg": "CmtE",
	"./godaddy.svg": "cMH2",
	"./gogs.png": "c0sd",
	"./google-cloud-cdn.svg": "S5i+",
	"./google-cloud-storage.svg": "g2QL",
	"./google-cloud-trace.svg": "PhAU",
	"./google_cloud.svg": "HxKB",
	"./gosquared.png": "9KUA",
	"./govCMS.svg": "5Ogi",
	"./govuk.png": "LdIv",
	"./gravityforms.svg": "WueQ",
	"./gunicorn.png": "SHtS",
	"./hCaptcha.svg": "OsZh",
	"./hantana.png": "NqeI",
	"./hashnode.png": "+Dyb",
	"./heroku.svg": "yBDV",
	"./hinza_advanced_cms.svg": "II72",
	"./hoolah.png": "1jaA",
	"./http2.png": "G3OI",
	"./hypercorn.png": "bXbl",
	"./i-MSCP.png": "cuAg",
	"./i-mobile.png": "mBqZ",
	"./iAdvize.svg": "GvHy",
	"./iEXExchanger.png": "Va0a",
	"./iHomefinder IDX.png": "FuMs",
	"./iPresta.png": "wkn+",
	"./iSina Chat.svg": "yBdp",
	"./iThemes Security.svg": "qx4k",
	"./iWeb.png": "fyFR",
	"./idCloudHost.png": "vWXM",
	"./idosellshop.png": "JEpo",
	"./ikiwiki.png": "cNHO",
	"./imperiaCMS.svg": "E6wc",
	"./inSided.svg": "7ESP",
	"./inspectlet.png": "6qo1",
	"./ionic.png": "7Y2r",
	"./ip-api.png": "n3xM",
	"./ipapi.co.png": "Wzm1",
	"./ipapi.png": "dM1G",
	"./ipdata.png": "yPNS",
	"./ipgeolocation.png": "bwZL",
	"./ipify.png": "f6my",
	"./iplabel.svg": "uHCy",
	"./ipstack.png": "0fpU",
	"./irroba.svg": "QeDr",
	"./iubenda.png": "NFqN",
	"./iubenda.svg": "FV4T",
	"./j2store.png": "CPCh",
	"./jComponent.png": "y1Lz",
	"./jQTouch.png": "M68f",
	"./jQuery Mobile.svg": "B0kB",
	"./jQuery Modal.png": "fcRc",
	"./jQuery UI.svg": "M1B5",
	"./jQuery.svg": "BlNv",
	"./jimdo.png": "C83s",
	"./jqPlot.png": "peAP",
	"./jsdelivr-icon.svg": "LsZg",
	"./k-eCommerce.png": "wR+7",
	"./keap.svg": "nSct",
	"./keep. archeevo.png": "t4Rk",
	"./kemalcr.png": "ai+5",
	"./kestrel.svg": "tkI7",
	"./kibana.svg": "v4DM",
	"./kinsta.svg": "pvYd",
	"./koha.png": "6sfW",
	"./langify.png": "8rP9",
	"./laterpay.png": "h3pc",
	"./lede.png": "9NpB",
	"./libravatar.png": "SmJt",
	"./libwww-perl-daemon.png": "p633",
	"./lighttpd.png": "fvY2",
	"./lighttpd.svg": "UQVM",
	"./liquidweb.svg": "NFm7",
	"./litespeed-cache.png": "2W5l",
	"./mParticle.svg": "K6o4",
	"./mailchimp.svg": "TR8h",
	"./mariadb.svg": "SpqQ",
	"./marked.svg": "M56i",
	"./math.js.png": "bXjn",
	"./mattermost.png": "imZS",
	"./mautic.svg": "OlBA",
	"./mdBook.svg": "wyiT",
	"./melis-platform.svg": "uo7a",
	"./metomic.png": "NstM",
	"./microCMS.svg": "Xg+s",
	"./mini_httpd.png": "Dmag",
	"./mirrAR.png": "HZ6T",
	"./miva.png": "FBFY",
	"./mkdocs.png": "+bnN",
	"./mobirise.png": "HL2a",
	"./mod_perl.png": "UUI1",
	"./mod_python.png": "gL92",
	"./mod_ssl.png": "hl5O",
	"./mod_wsgi.png": "dwvl",
	"./model-viewer.svg": "8Ego",
	"./modified.png": "lOVd",
	"./moon.svg": "fo3v",
	"./mouseflow.png": "z4Rs",
	"./mycashflow.png": "DAwl",
	"./myfoodlink.png": "adEs",
	"./nepso.svg": "H7Ur",
	"./nexcess.png": "cq65",
	"./node.js.png": "W5EJ",
	"./nopCommerce.png": "Df6w",
	"./nopStation.png": "YCX+",
	"./novomind.svg": "feo6",
	"./nuvem.png": "+1Xn",
	"./octopress.png": "AlHY",
	"./openpay.png": "PUeL",
	"./openxchange.svg": "8WQb",
	"./orocommerce.svg": "V7j0",
	"./osCommerce.png": "7eR3",
	"./osTicket.png": "cG/Z",
	"./osano.png": "c7Iy",
	"./otrs.png": "31oH",
	"./ownCloud.png": "nC8U",
	"./pagefly.png": "uBxQ",
	"./pagely.svg": "pnCM",
	"./pantheon.svg": "uQAS",
	"./papaya CMS.png": "SimD",
	"./paperjs.png": "sfaW",
	"./parselecom.png": "QGsK",
	"./paywhirl.png": "5LoH",
	"./pelican.png": "JYZU",
	"./percona.svg": "wtoH",
	"./perimeterx.svg": "zsoR",
	"./phpAlbum.png": "rbFa",
	"./phpBB.png": "1rC6",
	"./phpDocumentor.png": "k3Ue",
	"./phpMyAdmin.png": "WCu+",
	"./phpPgAdmin.png": "sTqz",
	"./phpSQLiteCMS.png": "2k9F",
	"./phpdebugbar.png": "C9x0",
	"./phpwind.png": "0J4K",
	"./pico.svg": "UkFI",
	"./pimcore.svg": "jn2K",
	"./pinoox.png": "Q29h",
	"./pinpayments.png": "VXej",
	"./pirobaseCMS.svg": "8WnN",
	"./pixijs.png": "0HKR",
	"./platformsh.svg": "EYFX",
	"./plentyShop LTS.svg": "SbK/",
	"./plentymarkets.svg": "HHWy",
	"./polyfill.svg": "UzB6",
	"./powerboutique.png": "ZIYf",
	"./pressable.svg": "tMLk",
	"./prettyPhoto.png": "sWCl",
	"./projesoft.png": "lZ8S",
	"./pubsub-js.png": "L7yF",
	"./punBB.png": "uKLG",
	"./pygments.png": "Tfj1",
	"./qiankun.svg": "7xEZ",
	"./question2answer.png": "/e+I",
	"./raychat.png": "hdgh",
	"./reCAPTCHA.svg": "10Qc",
	"./redoc.png": "zQIp",
	"./revslider.png": "4Z+A",
	"./riskified.png": "faj6",
	"./route.png": "AsX+",
	"./sIFR.png": "XR17",
	"./sNews.png": "lxxA",
	"./salecycle.svg": "zi33",
	"./salesfloor.png": "OJha",
	"./sazito-phoenix.png": "4JL/",
	"./script.aculo.us.png": "lSJA",
	"./scrollreveal.svg": "XYkW",
	"./sectionio.svg": "y1nx",
	"./seersco.png": "Hl/M",
	"./seravo.svg": "HDk8",
	"./shopline.svg": "m5V2",
	"./signal.png": "kx4a",
	"./siimple.svg": "Fxk9",
	"./simbel.svg": "LZqC",
	"./siteground.svg": "Y81e",
	"./snigel.svg": "fWo7",
	"./softtr.png": "j6yi",
	"./solvvy.png": "0/Bz",
	"./sonar.png": "eTgr",
	"./spip.svg": "kKNr",
	"./splitbee.svg": "CI+D",
	"./splitit.png": "Ln4H",
	"./stimulus-reflex-logo.svg": "SucW",
	"./storeden.svg": "dYHe",
	"./stores.jp.svg": "jrn3",
	"./storyblok.png": "vpwC",
	"./strapdown.js.png": "peS7",
	"./strato.png": "Q5Yo",
	"./strattic-icon.png": "9yMa",
	"./styled-components.png": "4ESc",
	"./sucuri.png": "yaUQ",
	"./svbtle.png": "t0p5",
	"./swift.engine.png": "Ckjl",
	"./swiftype.png": "gOe3",
	"./swiper.svg": "YjuN",
	"./sympa.png": "wIJg",
	"./syncfusion.svg": "XB3/",
	"./tagcommander.png": "3Ga0",
	"./tailwindcss.svg": "O/gO",
	"./tajs.png": "xeeK",
	"./termly.svg": "x0xr",
	"./tessitura.svg": "6mvM",
	"./textalk.svg": "rsRv",
	"./theTradeDesk.svg": "Ro32",
	"./threatmetrix.png": "z6h9",
	"./three.js.png": "sxn5",
	"./thttpd.png": "sm4I",
	"./tictail.png": "AJZU",
	"./tnsi.png": "hIGw",
	"./toastr.png": "8ymo",
	"./total.js.png": "BonW",
	"./townnews.png": "Nr9N",
	"./transifex.png": "d8jw",
	"./translucide.svg": "c17/",
	"./tray.png": "/7Fu",
	"./triplewhale.svg": "cJVv",
	"./trix.png": "GRaZ",
	"./trove.png": "NYWE",
	"./typecho.svg": "Bd1l",
	"./uKnowva.png": "F/2+",
	"./uLogin.png": "JEkB",
	"./uPortal.png": "/u4P",
	"./umami.svg": "g43o",
	"./upvoty.png": "2AiL",
	"./user.com.svg": "XN4A",
	"./utterances.png": "sERm",
	"./uvicorn.png": "RK4A",
	"./vBulletin.png": "mVzp",
	"./varbase.png": "vGiz",
	"./vcita.svg": "mn0l",
	"./vercel.svg": "QHoi",
	"./vibecommerce.png": "FP+2",
	"./vigbo.png": "tN3C",
	"./visa.png": "l74u",
	"./visualcomposer.svg": "PIj3",
	"./vite.svg": "5r8t",
	"./vk.svg": "cRke",
	"./vue-storefront.svg": "JVZL",
	"./vue.svg": "dawx",
	"./vwo.svg": "Dj89",
	"./web-vitals.svg": "LLqM",
	"./webAR.svg": "rStz",
	"./webEdition.png": "qktx",
	"./webdev.png": "nWvF",
	"./webflow.svg": "fjkA",
	"./webpack.svg": "QKzf",
	"./websocket.png": "uMmC",
	"./welcart.png": "Ejxr",
	"./wikinggruppen.png": "mB2J",
	"./wisyCMS.svg": "9osq",
	"./worldshopping.png": "7rBc",
	"./wpBakery.svg": "xg5S",
	"./wpCache.png": "ta2y",
	"./wp_super_cache.png": "c4xm",
	"./wpengine.svg": "aMSz",
	"./wpvip.svg": "sG7s",
	"./xeora.png": "I6gE",
	"./xonic.png": "Uzkr",
	"./xtCommerce.png": "qBVb",
	"./xwiki.png": "srry",
	"./yahoo.png": "LVpn",
	"./yellow.ai.svg": "jwEC",
	"./yepcomm.png": "pydW",
	"./yoast-seo-shopify.png": "jOVk",
	"./zip_pay.svg": "LeAJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1DuO";